export enum Category {
  Drug = 'DRUG',
  Environment = 'ENVIRONMENT',
  Food = 'FOOD',
}

export interface StandardAllergy {
  name: string;
  displayName: string;
  category: Category;
}

export enum AllergyName {
  Acetaminophen = 'ACETAMINOPHEN',
  AcetaminophenAspirinCaffeine = 'ACETAMINOPHEN_ASPIRIN_CAFFEINE',
  AcetaminophenCodeine = 'ACETAMINOPHEN_CODEINE',
  AcetaminophenDextromethorphanDoxylaminePse = 'ACETAMINOPHEN_DEXTROMETHORPHAN_DOXYLAMINE_PSE',
  AcetaminophenDiphenhydramine = 'ACETAMINOPHEN_DIPHENHYDRAMINE',
  AcetaminophenHydrocodone = 'ACETAMINOPHEN_HYDROCODONE',
  AcetaminophenOxycodone = 'ACETAMINOPHEN_OXYCODONE',
  AcetaminophenPropoxyphene = 'ACETAMINOPHEN_PROPOXYPHENE',
  AcetaminophenTramadol = 'ACETAMINOPHEN_TRAMADOL',
  Acetazolamide = 'ACETAZOLAMIDE',
  Acyclovir = 'ACYCLOVIR',
  Adalimumab = 'ADALIMUMAB',
  Adhesive = 'ADHESIVE',
  AdhesiveBandage = 'ADHESIVE_BANDAGE',
  AdhesiveTape = 'ADHESIVE_TAPE',
  Albuterol = 'ALBUTEROL',
  AlbuterolIpratropium = 'ALBUTEROL_IPRATROPIUM',
  Alendronate = 'ALENDRONATE',
  Allopurinol = 'ALLOPURINOL',
  AloeVera = 'ALOE_VERA',
  Alprazolam = 'ALPRAZOLAM',
  Amantadine = 'AMANTADINE',
  Amiodarone = 'AMIODARONE',
  Amitriptyline = 'AMITRIPTYLINE',
  Amlodipine = 'AMLODIPINE',
  AmlodipineBenazepril = 'AMLODIPINE_BENAZEPRIL',
  Amoxicillin = 'AMOXICILLIN',
  AmoxicillinClavulanate = 'AMOXICILLIN_CLAVULANATE',
  AmphetamineDextroamphetamine = 'AMPHETAMINE_DEXTROAMPHETAMINE',
  Ampicillin = 'AMPICILLIN',
  AmpicillinSulbactam = 'AMPICILLIN_SULBACTAM',
  Anastrozole = 'ANASTROZOLE',
  AnimalDander = 'ANIMAL_DANDER',
  ApapDichloralphenazoneIsometheptene = 'APAP_DICHLORALPHENAZONE_ISOMETHEPTENE',
  Apixaban = 'APIXABAN',
  AppleJuice = 'APPLE_JUICE',
  Aripiprazole = 'ARIPIPRAZOLE',
  AscorbicAcid = 'ASCORBIC_ACID',
  Aspartame = 'ASPARTAME',
  Aspirin = 'ASPIRIN',
  AspirinButalbitalCaffeine = 'ASPIRIN_BUTALBITAL_CAFFEINE',
  AspirinDipyridamole = 'ASPIRIN_DIPYRIDAMOLE',
  AspirinOxycodone = 'ASPIRIN_OXYCODONE',
  Atenolol = 'ATENOLOL',
  Atomoxetine = 'ATOMOXETINE',
  Atorvastatin = 'ATORVASTATIN',
  Atropine = 'ATROPINE',
  AtropineDiphenoxylate = 'ATROPINE_DIPHENOXYLATE',
  AtropineHyoscyaminePbScopolamine = 'ATROPINE_HYOSCYAMINE_PB_SCOPOLAMINE',
  Augmentin = 'AUGMENTIN',
  Azathioprine = 'AZATHIOPRINE',
  Azithromycin = 'AZITHROMYCIN',
  Bacitracin = 'BACITRACIN',
  BacitracinNeomycinPolymyxinBTopical = 'BACITRACIN_NEOMYCIN_POLYMYXIN_B_TOPICAL',
  BacitracinPolymyxinBTopical = 'BACITRACIN_POLYMYXIN_B_TOPICAL',
  Baclofen = 'BACLOFEN',
  Bactrim = 'BACTRIM',
  Banana = 'BANANA',
  BariumSulfate = 'BARIUM_SULFATE',
  BeePollen = 'BEE_POLLEN',
  BeeStings = 'BEE_STINS',
  Benazepril = 'BENAZEPRIL',
  Benzocaine = 'BENZOCAINE',
  BenzoinTopical = 'BENZOIN_TOPICAL',
  Benzonatate = 'BENZONATATE',
  BenzoylPeroxideTopical = 'BENZOYL_PEROXIDE_TOPICAL',
  Benztropine = 'BENZTROPINE',
  BismuthSubsalicylate = 'BISMUTH_SUBSALICYLATE',
  BrimonidineOphthalmic = 'BRIMONIDINE_OPHTHALMIC',
  BrimonidineTimololOphthalmic = 'BRIMONIDINE_TIMOLOL_OPHTHALMIC',
  BudesonideFormoterol = 'BUDESONIDE_FORMOTEROL',
  BudesonideNasal = 'BUDESONIDE_NASAL',
  Bumetanide = 'BUMETANIDE',
  Bupivacaine = 'BUPIVACAINE',
  Buprenorphine = 'BUPRENORPHINE',
  Bupropion = 'BUPROPION',
  Buspirone = 'BUSPIRONE',
  Butorphanol = 'BUTORPHANOL',
  Caffeine = 'CAFFEINE',
  CaffeineErgotamine = 'CAFFEINE_ERGOTAMINE',
  Calcitonin = 'CALCITONIN',
  CalciumCarbonate = 'CALCIUM_CARBONATE',
  CamphorEucalyptusMentholTopical = 'CAMPHOR_EUCALYPTUS_MENTHOL_TOPICAL',
  Canagliflozin = 'CANAGLIFLOZIN',
  Candesartan = 'CANDESARTAN',
  Captopril = 'CAPTOPRIL',
  Carbamazepine = 'CARBAMAZEPINE',
  CarbidopaLevodopa = 'CARBIDOPA_LEVODOPA',
  Carboplatin = 'CARBOPLATIN',
  CarboxymethylcelluloseOphthalmic = 'CARBOXYMETHYLCELLULOSE_OPHTHALMIC',
  Carisoprodol = 'CARISOPRODOL',
  Carvedilol = 'CARVEDILOL',
  Cats = 'CATS',
  Cefaclor = 'CEFACLOR',
  Cefadroxil = 'CEFADROXIL',
  Cefazolin = 'CEFAZOLIN',
  Cefdinir = 'CEFDINIR',
  Cefepime = 'CEFEPIME',
  Cefixime = 'CEFIXIME',
  Cefoxitin = 'CEFOXITIN',
  Cefpodoxime = 'CEFPODOXIME',
  Cefprozil = 'CEFPROZIL',
  Ceftriaxone = 'CEFTRIAXONE',
  Cefuroxime = 'CEFUROXIME',
  Celecoxib = 'CELECOXIB',
  Cephalexin = 'CEPHALEXIN',
  Cetirizine = 'CETIRIZINE',
  Cherry = 'CHERRY',
  ChlorhexidineTopical = 'CHLORHEXIDINE_TOPICAL',
  ChlorpheniramineHydrocodone = 'CHLORPHENIRAMINE_HYDROCODONE',
  ChlorpheniraminePseudoephedrine = 'CHLORPHENIRAMINE_PSEUDOEPHEDRINE',
  Chlorpromazine = 'CHLORPROMAZINE',
  Chlorthalidone = 'CHLORTHALIDONE',
  Chlorzoxazone = 'CHLORZOXAZONE',
  Chocolate = 'CHOCOLATE',
  Cholestyramine = 'CHOLESTYRAMINE',
  ChondroitinGlucosamine = 'CHONDROITIN_GLUCOSAMINE',
  Cilostazol = 'CILOSTAZOL',
  Cimetidine = 'CIMETIDINE',
  Cinnamon = 'CINNAMON',
  Ciprofloxacin = 'CIPROFLOXACIN',
  Cisatracurium = 'CISATRACURIUM',
  Citalopram = 'CITALOPRAM',
  CitricAcid = 'CITRIC_ACID',
  Clarithromycin = 'CLARITHROMYCIN',
  Clavulanate = 'CLAVULANATE',
  Clindamycin = 'CLINDAMYCIN',
  ClobetasolTopical = 'CLOBETASOL_TOPICAL',
  Clonazepam = 'CLONAZEPAM',
  Clonidine = 'CLONIDINE',
  Clopidogrel = 'CLOPIDOGREL',
  Clotrimazole = 'CLOTRIMAZOLE',
  CoconutOil = 'COCONUT_OIL',
  Codeine = 'CODEINE',
  CodeineGuaifenesin = 'CODEINE_GUAIFENESIN',
  Colchicine = 'COLCHICINE',
  Colesevelam = 'COLESEVELAM',
  Colestipol = 'COLESTIPOL',
  ConjugatedEstrogens = 'CONJUGATED_ESTROGENS',
  CopperChloride = 'COPPER_CHLORIDE',
  Corn = 'CORN',
  Cortisone = 'CORTISONE',
  CowsMilk = 'COWS_MILK',
  Cranberry = 'CRANBERRY',
  Dandelion = 'DANDELION',
  Dapagliflozin = 'DAPAGLIFLOZIN',
  Dapsone = 'DAPSONE',
  Demerol = 'DEMEROL',
  Desipramine = 'DESIPRAMINE',
  Desvenlafaxine = 'DESVENLAFAXINE',
  Dexamethasone = 'DEXAMETHASONE',
  DexamethasoneNeomycinPolymyxinBOphthalmic = 'DEXAMETHASONE_NEOMYCIN_POLYMYXIN_B_OPHTHALMIC',
  Dexlansoprazole = 'DEXLANSOPRAZOLE',
  Dexmedetomidine = 'DEXMEDETOMIDINE',
  Dexmethylphenidate = 'DEXMETHYLPHENIDATE',
  Dextromethorphan = 'DEXTROMETHORPHAN',
  DextromethorphanDoxylamine = 'DEXTROMETHORPHAN_DOXYLAMINE',
  DextromethorphanGuaifenesin = 'DEXTROMETHORPHAN_GUAIFENESIN',
  Diazepam = 'DIAZEPAM',
  Diclofenac = 'DICLOFENAC',
  DiclofenacMisoprostol = 'DICLOFENAC_MISOPROSTOL',
  Dicloxacillin = 'DICLOXACILLIN',
  Dicyclomine = 'DICYCLOMINE',
  Diflunisal = 'DIFLUNISAL',
  Digoxin = 'DIGOXIN',
  Dihydroergotamine = 'DIHYDROERGOTAMINE',
  Diltiazem = 'DILTIAZEM',
  Diphenhydramine = 'DIPHENHYDRAMINE',
  Disulfiram = 'DISULFIRAM',
  Dogs = 'DOGS',
  Donepezil = 'DONEPEZIL',
  Doripenem = 'DORIPENEM',
  DorzolamideOphthalmic = 'DORZOLAMIDE_OPHTHALMIC',
  DorzolamideTimololOphthalmic = 'DORZOLAMIDE_TIMOLOL_OPHTHALMIC',
  Doxazosin = 'DOXAZOSIN',
  Doxepin = 'DOXEPIN',
  Doxycycline = 'DOXYCYCLINE',
  Dronedarone = 'DRONEDARONE',
  Droperidol = 'DROPERIDOL',
  DrospirenoneEthinylEstradiol = 'DROSPIRENONE_ETHINYL_ESTRADIOL',
  Dulaglutide = 'DULAGLUTIDE',
  Duloxetine = 'DULOXETINE',
  Dust = 'DUST',
  Eggs = 'EGGS',
  Eletriptan = 'ELETRIPTAN',
  Empagliflozin = 'EMPAGLIFLOZIN',
  Enalapril = 'ENALAPRIL',
  Enoxaparin = 'ENOXAPARIN',
  EnvironmentalAllergy = 'ENVIRONMENTAL_ALLERGY',
  Ephedrine = 'EPHEDRINE',
  Epinephrine = 'EPINEPHRINE',
  EpinephrineLidocaine = 'EPINEPHRINE_LIDOCAINE',
  Ertapenem = 'ERTAPENEM',
  Erythromycin = 'ERYTHROMYCIN',
  ErythromycinSulfisoxazole = 'ERYTHROMYCIN_SULFISOXAZOLE',
  Escitalopram = 'ESCITALOPRAM',
  Esomeprazole = 'ESOMEPRAZOLE',
  Estradiol = 'ESTRADIOL',
  Estrogens = 'ESTROGENS',
  Eszopiclone = 'ESZOPICLONE',
  Etanercept = 'ETANERCEPT',
  Ethanol = 'ETHANOL',
  EthinylEstradiol = 'ETHINYL_ESTRADIOL',
  EthinylEstradiolLevonorgestrel = 'ETHINYL_ESTRADIOL_LEVONORGESTREL',
  EthinylEstradiolNorelgestromin = 'ETHINYL_ESTRADIOL_NORELGESTROMIN',
  EthinylEstradiolNorgestimate = 'ETHINYL_ESTRADIOL_NORGESTIMATE',
  Etodolac = 'ETODOLAC',
  Etomidate = 'ETOMIDATE',
  Exenatide = 'EXENATIDE',
  Ezetimibe = 'EZETIMIBE',
  EzetimibeSimvastatin = 'EZETIMIBE_SIMVASTATIN',
  Famotidine = 'FAMOTIDINE',
  Felodipine = 'FELODIPINE',
  Fenofibrate = 'FENOFIBRATE',
  Fentanyl = 'FENTANYL',
  FerrousSulfate = 'FERROUS_SULFATE',
  Fexofenadine = 'FEXOFENADINE',
  FexofenadinePseudoephedrine = 'FEXOFENADINE_PSEUDOEPHEDRINE',
  Finasteride = 'FINASTERIDE',
  Fish = 'FISH',
  FishOil = 'FISH_OIL',
  Flax = 'FLAX',
  Flecainide = 'FLECAINIDE',
  Fluconazole = 'FLUCONAZOLE',
  Fluorescein = 'FLUORESCEIN',
  FluorideContainingCompounds = 'FLUORIDE_CONTAINING_COMPOUNDS',
  Fluoxetine = 'FLUOXETINE',
  Fluphenazine = 'FLUPHENAZINE',
  Fluticasone = 'FLUTICASONE',
  FluticasoneSalmeterol = 'FLUTICASONE_SALMETEROL',
  Fluvastatin = 'FLUVASTATIN',
  Formaldehyde = 'FORMALDEHYDE',
  Fosinopril = 'FOSINOPRIL',
  Fructose = 'FRUCTOSE',
  Furosemide = 'FUROSEMIDE',
  Gabapentin = 'GABAPENTIN',
  GadoliniumContainingCompounds = 'GADOLINIUM_CONTAINING_COMPOUNDS',
  Garlic = 'GARLIC',
  Gatifloxacin = 'GATIFLOXACIN',
  Gemfibrozil = 'GEMFIBROZIL',
  Gentamicin = 'GENTAMICIN',
  Ginger = 'GINGER',
  Glatiramer = 'GLATIRAMER',
  Glimepiride = 'GLIMEPIRIDE',
  Glipizide = 'GLIPIZIDE',
  Glucosamine = 'GLUCOSAMINE',
  Glucose = 'GLUCOSE',
  Gluten = 'GLUTEN',
  Glyburide = 'GLYBURIDE',
  GoldContainingCompounds = 'GOLD_CONTAINING_COMPOUNDS',
  GramicidinNeomycinPolymyxinBOphthalmic = 'GRAMICIDIN_NEOMYCIN_POLYMYXIN_B_OPHTHALMIC',
  Grass = 'GRASS',
  Griseofulvin = 'GRISEOFULVIN',
  Guaifenesin = 'GUAIFENESIN',
  GuaifenesinPhenylephrine = 'GUAIFENESIN_PHENYLEPHRINE',
  GuaifenesinPseudoephedrine = 'GUAIFENESIN_PSEUDOEPHEDRINE',
  Guanfacine = 'GUANFACINE',
  Haldol = 'HALDOL',
  Haloperidol = 'HALOPERIDOL',
  Hay = 'HAY',
  Heparin = 'HEPARIN',
  HepatitisBVaccines = 'HEPATITIS_B_VACCINES',
  Horses = 'HORSES',
  HouseDustMiteAllergenExtract = 'HOUSE_DUST_MITE_ALLERGEN_EXTRACT',
  HumanPapillomavirusVaccine = 'HUMAN_PAPILLOMAVIRUS_VACCINE',
  Hydralazine = 'HYDRALAZINE',
  Hydrochlorothiazide = 'HYDROCHLOROTHIAZIDE',
  HydrochlorothiazideLisinopril = 'HYDROCHLOROTHIAZIDE_LISINOPRIL',
  HydrochlorothiazideLosartan = 'HYDROCHLOROTHIAZIDE_LOSARTAN',
  HydrochlorothiazideSpironolactone = 'HYDROCHLOROTHIAZIDE_SPIRONOLACTONE',
  HydrochlorothiazideTriamterene = 'HYDROCHLOROTHIAZIDE_TRIAMTERENE',
  Hydrocodone = 'HYDROCODONE',
  Hydrocortisone = 'HYDROCORTISONE',
  HydrocortisoneNeomycinPolymyxinBOtic = 'HYDROCORTISONE_NEOMYCIN_POLYMYXIN_B_OTIC',
  HydrogenPeroxideTopical = 'HYDROGEN_PEROXIDE_TOPICAL',
  Hydromorphone = 'HYDROMORPHONE',
  Hydroxychloroquine = 'HYDROXYCHLOROQUINE',
  Hydroxyzine = 'HYDROXYZINE',
  HylanGF20 = 'HYLAN_G_F_20',
  Hyoscyamine = 'HYOSCYAMINE',
  Ibandronate = 'IBANDRONATE',
  Ibuprofen = 'IBUPROFEN',
  Imipenem = 'IMIPENEM',
  Imipramine = 'IMIPRAMINE',
  Indomethacin = 'INDOMETHACIN',
  Infliximab = 'INFLIXIMAB',
  InfluenzaVirusVaccineInactivated = 'INFLUENZA_VIRUS_VACCINE_INACTIVATED',
  InfluenzaVirusVaccineLive = 'INFLUENZA_VIRUS_VACCINE_LIVE',
  Insulin = 'INSULIN',
  InsulinDetemir = 'INSULIN_DETEMIR',
  InsulinGlargine = 'INSULIN_GLARGINE',
  IodinatedContrast = 'IODINATED_CONTRAST',
  Iodine = 'IODINE',
  IodineContainingCompounds = 'IODINE_CONTAINING_COMPOUNDS',
  Iopamidol = 'IOPAMIDOL',
  Ipratropium = 'IPRATROPIUM',
  Irbesartan = 'IRBESARTAN',
  Iron = 'IRON',
  IronDextran = 'IRON_DEXTRAN',
  IronPolysaccharide = 'IRON_POLYSACCHARIDE',
  Isoniazid = 'ISONIAZID',
  IsopropylAlcoholTopical = 'ISOPROPYL_ALCOHOL_TOPICAL',
  IsosorbideDinitrate = 'ISOSORBIDE_DINITRATE',
  Itraconazole = 'ITRACONAZOLE',
  Keflex = 'KEFLEX',
  Ketamine = 'KETAMINE',
  Ketoconazole = 'KETOCONAZOLE',
  Ketoprofen = 'KETOPROFEN',
  Ketorolac = 'KETOROLAC',
  Kiwi = 'KIWI',
  Labetalol = 'LABETALOL',
  Lactase = 'LACTASE',
  Lactose = 'LACTOSE',
  Lamotrigine = 'LAMOTRIGINE',
  Lansoprazole = 'LANSOPRAZOLE',
  LatanoprostOphthalmic = 'LATANOPROST_OPHTHALMIC',
  Latex = 'LATEX',
  Leflunomide = 'LEFLUNOMIDE',
  Levetiracetam = 'LEVETIRACETAM',
  LevofloxacinLevaquin = 'LEVOFLOXACIN_LEVAQUIN',
  Levothyroxine = 'LEVOTHYROXINE',
  Lidocaine = 'LIDOCAINE',
  Linezolid = 'LINEZOLID',
  Liraglutide = 'LIRAGLUTIDE',
  Lisdexamfetamine = 'LISDEXAMFETAMINE',
  Lisinopril = 'LISINOPRIL',
  Lithium = 'LITHIUM',
  Lobster = 'LOBSTER',
  Loperamide = 'LOPERAMIDE',
  Loracarbef = 'LORACARBEF',
  Loratadine = 'LORATADINE',
  LoratadinePseudoephedrine = 'LORATADINE_PSEUDOEPHEDRINE',
  Lorazepam = 'LORAZEPAM',
  Losartan = 'LOSARTAN',
  Lovastatin = 'LOVASTATIN',
  Lubiprostone = 'LUBIPROSTONE',
  Lurasidone = 'LURASIDONE',
  MagnesiumGluconate = 'MAGNESIUM_GLUCONATE',
  Mannitol = 'MANNITOL',
  MeaslesMumpsRubellaVirusVaccine = 'MEASLES_MUMPS_RUBELLA_VIRUS_VACCINE',
  Meclizine = 'MECLIZINE',
  Medroxyprogesterone = 'MEDROXYPROGESTERONE',
  Melatonin = 'MELATONIN',
  Meloxicam = 'MELOXICAM',
  MentholMethylSalicylateTopical = 'MENTHOL_METHYL_SALICYLATE_TOPICAL',
  Meperidine = 'MEPERIDINE',
  Mercaptopurine = 'MERCAPTOPURINE',
  Meropenem = 'MEROPENEM',
  Mesalamine = 'MESALAMINE',
  Metal = 'METAL',
  Metaxalone = 'METAXALONE',
  Metformin = 'METFORMIN',
  Methadone = 'METHADONE',
  Methimazole = 'METHIMAZOLE',
  Methocarbamol = 'METHOCARBAMOL',
  Methotrexate = 'METHOTREXATE',
  Methyldopa = 'METHYLDOPA',
  Methylphenidate = 'METHYLPHENIDATE',
  Methylprednisolone = 'METHYLPREDNISOLONE',
  Metoclopramide = 'METOCLOPRAMIDE',
  Metoprolol = 'METOPROLOL',
  Metronidazole = 'METRONIDAZOLE',
  MiconazoleTopical = 'MICONAZOLE TOPICAL',
  Midazolam = 'MIDAZOLAM',
  Milnacipran = 'MILNACIPRAN',
  Minocycline = 'MINOCYCLINE',
  Mirtazapine = 'MIRTAZAPINE',
  Mites = 'MITES',
  Modafinil = 'MODAFINIL',
  Mold = 'MOLD',
  Montelukast = 'MONTELUKAST',
  Morphine = 'MORPHINE',
  Moxifloxacin = 'MOXIFLOXACIN',
  Msg = 'MSG',
  Multivitamin = 'MULTIVITAMIN',
  MupirocinTopical = 'MUPIROCIN_TOPICAL',
  Mushrooms = 'MUSHROOMS',
  Nabumetone = 'NABUMETONE',
  Nadolol = 'NADOLOL',
  Nafcillin = 'NAFCILLIN',
  Nalbuphine = 'NALBUPHINE',
  NaloxonePentazocine = 'NALOXONE_PENTAZOCINE',
  Naltrexone = 'NALTREXONE',
  Naproxen = 'NAPROXEN',
  Nebivolol = 'NEBIVOLOL',
  Nefazodone = 'NEFAZODONE',
  Neomycin = 'NEOMYCIN',
  Niacin = 'NIACIN',
  Nickel = 'NICKEL',
  Nicotine = 'NICOTINE',
  Nifedipine = 'NIFEDIPINE',
  Nitrofurantoin = 'NITROFURANTOIN',
  Nitroglycerin = 'NITROGLYCERIN',
  NitrousOxide = 'NITROUS_OXIDE',
  Norethindrone = 'NORETHINDRONE',
  Nortriptyline = 'NORTRIPTYLINE',
  Nsaids = 'NSAIDS',
  Nuts = 'NUTS',
  Nystatin = 'NYSTATIN',
  Ofloxacin = 'OFLOXACIN',
  Olanzapine = 'OLANZAPINE',
  Olmesartan = 'OLMESARTAN',
  Omega3PolyunsaturatedFattyAcids = 'OMEGA_3_POLYUNSATURATED_FATTY_ACIDS',
  Omeprazole = 'OMEPRAZOLE',
  Ondansetron = 'ONDANSETRON',
  Onion = 'ONION',
  Oranges = 'ORANGES',
  Orphenadrine = 'ORPHENADRINE',
  Oseltamivir = 'OSELTAMIVIR',
  Other = 'OTHER',
  Oxaprozin = 'OXAPROZIN',
  Oxcarbazepine = 'OXCARBAZEPINE',
  Oxybutynin = 'OXYBUTYNIN',
  Oxycodone = 'OXYCODONE',
  OxymetazolineNasal = 'OXYMETAZOLINE_NASAL',
  Oxytetracycline = 'OXYTETRACYCLINE',
  Paclitaxel = 'PACLITAXEL',
  Pancuronium = 'PANCURONIUM',
  Pantoprazole = 'PANTOPRAZOLE',
  Paroxetine = 'PAROXETINE',
  Peanut = 'PEANUT',
  PeanutAllergenExtract = 'PEANUT_ALLERGEN_EXTRACT',
  Penicillin = 'PENICILLIN',
  PenicillinGBenzathine = 'PENICILLIN_G_BENZATHINE',
  PenicillinVPotassium = 'PENICILLIN_V_POTASSIUM',
  Pentazocine = 'PENTAZOCINE',
  Peppermint = 'PEPPERMINT',
  Percocet = 'PERCOCET',
  Perflutren = 'PERFLUTREN',
  PermethrinTopical = 'PERMETHRIN_TOPICAL',
  Phenazopyridine = 'PHENAZOPYRIDINE',
  Phenobarbital = 'PHENOBARBITAL',
  Phentermine = 'PHENTERMINE',
  Phenylephrine = 'PHENYLEPHRINE',
  Phenytoin = 'PHENYTOIN',
  Pioglitazone = 'PIOGLITAZONE',
  PiperacillinTazobactam = 'PIPERACILLIN_TAZOBACTAM',
  Piroxicam = 'PIROXICAM',
  Pneumococcal13ValentConjugateVaccine = 'PNEUMOCOCCAL_13_VALENT_CONJUGATE_VACCINE',
  Pneumococcal23PolyvalentVaccine = 'PNEUMOCOCCAL_23_POLYVALENT_VACCINE',
  Pollen = 'POLLEN',
  PolyethyleneGlycol3350 = 'POLYETHYLENE_GLYCOL_3350',
  PolymyxinBSulfate = 'POLYMYXIN_B_SULFATE',
  PolymyxinBTrimethoprimOphthalmic = 'POLYMYXIN_B_TRIMETHOPRIM_OPHTHALMIC',
  Pork = 'PORK',
  PotassiumChloride = 'POTASSIUM_CHLORIDE',
  PovidoneIodine = 'POVIDONE_IODINE',
  Pramipexole = 'PRAMIPEXOLE',
  Pravastatin = 'PRAVASTATIN',
  Prazosin = 'PRAZOSIN',
  Prednisolone = 'PREDNISOLONE',
  Prednisone = 'PREDNISONE',
  Pregabalin = 'PREGABALIN',
  Primidone = 'PRIMIDONE',
  Procaine = 'PROCAINE',
  Prochlorperazine = 'PROCHLORPERAZINE',
  Progesterone = 'PROGESTERONE',
  Promethazine = 'PROMETHAZINE',
  Propofol = 'PROPOFOL',
  Propoxyphene = 'PROPOXYPHENE',
  Propranolol = 'PROPRANOLOL',
  Pseudoephedrine = 'PSEUDOEPHEDRINE',
  PseudoephedrineTriprolidine = 'PSEUDOEPHEDRINE_TRIPROLIDINE',
  Psyllium = 'PSYLLIUM',
  Quetiapine = 'QUETIAPINE',
  Quinapril = 'QUINAPRIL',
  Quinidine = 'QUINIDINE',
  Quinine = 'QUININE',
  Rabeprazole = 'RABEPRAZOLE',
  Ragweed = 'RAGWEED',
  Raloxifene = 'RALOXIFENE',
  Ramelteon = 'RAMELTEON',
  Ramipril = 'RAMIPRIL',
  Ranitidine = 'RANITIDINE',
  RedDye = 'RED_DYE',
  RedYeastRice = 'RED_YEAST_RICE',
  Rifampin = 'RIFAMPIN',
  Risedronate = 'RISEDRONATE',
  Risperidone = 'RISPERIDONE',
  Rituximab = 'RITUXIMAB',
  Rivaroxaban = 'RIVAROXABAN',
  Rizatriptan = 'RIZATRIPTAN',
  Rocuronium = 'ROCURONIUM',
  Rofecoxib = 'ROFECOXIB',
  Ropinirole = 'ROPINIROLE',
  Ropivacaine = 'ROPIVACAINE',
  Rosiglitazone = 'ROSIGLITAZONE',
  Rosuvastatin = 'ROSUVASTATIN',
  Rubber = 'RUBBER',
  Salsalate = 'SALSALATE',
  Scopolamine = 'SCOPOLAMINE',
  Seafood = 'SEAFOOD',
  Sertraline = 'SERTRALINE',
  Shellfish = 'SHELLFISH',
  Shrimp = 'SHRIMP',
  Sildenafil = 'SILDENAFIL',
  SilverSulfadiazineTopical = 'SILVER_SULFADIAZINE_TOPICAL',
  Simvastatin = 'SIMVASTATIN',
  Sitagliptin = 'SITAGLIPTIN',
  Solifenacin = 'SOLIFENACIN',
  Soy = 'SOY',
  Spironolactone = 'SPIRONOLACTONE',
  Strawberries = 'STRAWBERRIES',
  Streptomycin = 'STREPTOMYCIN',
  Succinylcholine = 'SUCCINYLCHOLINE',
  Sucralfate = 'SUCRALFATE',
  Sulfadiazine = 'SULFADIAZINE',
  SulfaMedications = 'SULFA_MEDICATIONS',
  Sulfamethoxazole = 'SULFAMETHOXAZOLE',
  SulfamethoxazoleTrimethoprim = 'SULFAMETHOXAZOLE_TRIMETHOPRIM',
  Sulfasalazine = 'SULFASALAZINE',
  Sulfisoxazole = 'SULFISOXAZOLE',
  SulfurTopical = 'SULFUR_TOPICAL',
  Sulindac = 'SULINDAC',
  Sumatriptan = 'SUMATRIPTAN',
  Tamoxifen = 'TAMOXIFEN',
  Tamsulosin = 'TAMSULOSIN',
  Tape = 'TAPE',
  Tapentadol = 'TAPENTADOL',
  Temazepam = 'TEMAZEPAM',
  Terazosin = 'TERAZOSIN',
  Terbinafine = 'TERBINAFINE',
  Terfenadine = 'TERFENADINE',
  Testosterone = 'TESTOSTERONE',
  TetanusDiphthToxoidsTdAdultAdol = 'TETANUS_DIPHTH_TOXOIDS_TD_ADULT_ADOL',
  TetanusImmuneGlobulin = 'TETANUS_IMMUNE_GLOBULIN',
  TetanusToxoid = 'TETANUS_TOXOID',
  Tetracycline = 'TETRACYCLINE',
  Tetrahydrozoline = 'TETRAHYDROZOLINE',
  Theophylline = 'THEOPHYLLINE',
  ThimerosalTopical = 'THIMEROSAL_TOPICAL',
  Thiopental = 'THIOPENTAL',
  Ticagrelor = 'TICAGRELOR',
  Timolol = 'TIMOLOL',
  TioconazoleTopical = 'TIOCONAZOLE_TOPICAL',
  Tiotropium = 'TIOTROPIUM',
  Tizanidine = 'TIZANIDINE',
  Tobramycin = 'TOBRAMYCIN',
  Tolmetin = 'TOLMETIN',
  Tolterodine = 'TOLTERODINE',
  Tomatoes = 'TOMATOES',
  Topiramate = 'TOPIRAMATE',
  Toradol = 'TORADOL',
  Tramadol = 'TRAMADOL',
  Trandolapril = 'TRANDOLAPRIL',
  TravoprostOphthalmic = 'TRAVOPROST_OPHTHALMIC',
  Trazodone = 'TRAZODONE',
  Triamcinolone = 'TRIAMCINOLONE',
  Triamterene = 'TRIAMTERENE',
  Trimethoprim = 'TRIMETHOPRIM',
  TuberculinPurifiedProteinDerivative = 'TUBERCULIN_PURIFIED_PROTEIN_DERIVATIVE',
  Valacyclovir = 'VALACYCLOVIR',
  Valdecoxib = 'VALDECOXIB',
  Valsartan = 'VALSARTAN',
  Vancomycin = 'VANCOMYCIN',
  Varenicline = 'VARENICLINE',
  VaricellaVirusVaccine = 'VARICELLA_VIRUS_VACCINE',
  Vecuronium = 'VECURONIUM',
  Venlafaxine = 'VENLAFAXINE',
  Verapamil = 'VERAPAMIL',
  VitaminE = 'VITAMIN_E',
  Warfarin = 'WARFARIN',
  Wheat = 'WHEAT',
  Zaleplon = 'ZALEPLON',
  ZincOxideTopical = 'ZINC_OXIDE_TOPICAL',
  ZincSulfate = 'ZINC_SULFATE',
  Ziprasidone = 'ZIPRASIDONE',
  ZoledronicAcid = 'ZOLEDRONIC_ACID',
  Zolmitriptan = 'ZOLMITRIPTAN',
  Zolpidem = 'ZOLPIDEM',
  Zonisamide = 'ZONISAMIDE',
  ZosterVaccineInactivated = 'ZOSTER_VACCINE_INACTIVATED',
}

export const AllergyNameToStandardAllergyMap: Record<
  AllergyName,
  StandardAllergy
> = {
  [AllergyName.Acetaminophen]: {
    category: Category.Drug,
    displayName: 'Acetaminophen',
    name: AllergyName.Acetaminophen,
  },
  [AllergyName.AdhesiveTape]: {
    category: Category.Environment,
    displayName: 'Adhesive Tape',
    name: AllergyName.AdhesiveTape,
  },
  [AllergyName.Alprazolam]: {
    category: Category.Drug,
    displayName: 'Alprazolam',
    name: AllergyName.Alprazolam,
  },
  [AllergyName.Amoxicillin]: {
    category: Category.Drug,
    displayName: 'Amoxicillin',
    name: AllergyName.Amoxicillin,
  },
  [AllergyName.AmoxicillinClavulanate]: {
    category: Category.Drug,
    displayName: 'Amoxicillin-clavulanate',
    name: AllergyName.AmoxicillinClavulanate,
  },
  [AllergyName.Ampicillin]: {
    category: Category.Drug,
    displayName: 'Ampicillin',
    name: AllergyName.Ampicillin,
  },
  [AllergyName.Aspirin]: {
    category: Category.Drug,
    displayName: 'Aspirin',
    name: AllergyName.Aspirin,
  },
  [AllergyName.Atorvastatin]: {
    category: Category.Drug,
    displayName: 'Atorvastatin',
    name: AllergyName.Atorvastatin,
  },
  [AllergyName.Augmentin]: {
    category: Category.Drug,
    displayName: 'Augmentin',
    name: AllergyName.Augmentin,
  },
  [AllergyName.Azithromycin]: {
    category: Category.Drug,
    displayName: 'Azithromycin',
    name: AllergyName.Azithromycin,
  },
  [AllergyName.Bactrim]: {
    category: Category.Drug,
    displayName: 'Bactrim',
    name: AllergyName.Bactrim,
  },
  [AllergyName.Bupivacaine]: {
    category: Category.Drug,
    displayName: 'Bupivacaine',
    name: AllergyName.Bupivacaine,
  },
  [AllergyName.Cefazolin]: {
    category: Category.Drug,
    displayName: 'Cefazolin',
    name: AllergyName.Cefazolin,
  },
  [AllergyName.Cefdinir]: {
    category: Category.Drug,
    displayName: 'Cefdinir',
    name: AllergyName.Cefdinir,
  },
  [AllergyName.Ceftriaxone]: {
    category: Category.Drug,
    displayName: 'Ceftriaxone',
    name: AllergyName.Ceftriaxone,
  },
  [AllergyName.Cefuroxime]: {
    category: Category.Drug,
    displayName: 'Cefuroxime',
    name: AllergyName.Cefuroxime,
  },
  [AllergyName.Celecoxib]: {
    category: Category.Drug,
    displayName: 'Celecoxib',
    name: AllergyName.Celecoxib,
  },
  [AllergyName.Cephalexin]: {
    category: Category.Drug,
    displayName: 'Cephalexin',
    name: AllergyName.Cephalexin,
  },
  [AllergyName.Ciprofloxacin]: {
    category: Category.Drug,
    displayName: 'Ciprofloxacin',
    name: AllergyName.Ciprofloxacin,
  },
  [AllergyName.Cisatracurium]: {
    category: Category.Drug,
    displayName: 'Cisatracurium',
    name: AllergyName.Cisatracurium,
  },
  [AllergyName.Clarithromycin]: {
    category: Category.Drug,
    displayName: 'Clarithromycin',
    name: AllergyName.Clarithromycin,
  },
  [AllergyName.Clindamycin]: {
    category: Category.Drug,
    displayName: 'Clindamycin',
    name: AllergyName.Clindamycin,
  },
  [AllergyName.Codeine]: {
    category: Category.Drug,
    displayName: 'Codeine',
    name: AllergyName.Codeine,
  },
  [AllergyName.Cortisone]: {
    category: Category.Drug,
    displayName: 'Cortisone',
    name: AllergyName.Cortisone,
  },
  [AllergyName.CowsMilk]: {
    category: Category.Food,
    displayName: "Cow's Milk",
    name: AllergyName.CowsMilk,
  },
  [AllergyName.Demerol]: {
    category: Category.Drug,
    displayName: 'Demerol',
    name: AllergyName.Demerol,
  },
  [AllergyName.Dexamethasone]: {
    category: Category.Drug,
    displayName: 'Dexamethasone',
    name: AllergyName.Dexamethasone,
  },
  [AllergyName.Dexmedetomidine]: {
    category: Category.Drug,
    displayName: 'Dexmedetomidine',
    name: AllergyName.Dexmedetomidine,
  },
  [AllergyName.Diazepam]: {
    category: Category.Drug,
    displayName: 'Diazepam',
    name: AllergyName.Diazepam,
  },
  [AllergyName.Diphenhydramine]: {
    category: Category.Drug,
    displayName: 'Diphenhydramine',
    name: AllergyName.Diphenhydramine,
  },
  [AllergyName.Doripenem]: {
    category: Category.Drug,
    displayName: 'Doripenem',
    name: AllergyName.Doripenem,
  },
  [AllergyName.Doxycycline]: {
    category: Category.Drug,
    displayName: 'Doxycycline',
    name: AllergyName.Doxycycline,
  },
  [AllergyName.Eggs]: {
    category: Category.Food,
    displayName: 'Eggs',
    name: AllergyName.Eggs,
  },
  [AllergyName.Enalapril]: {
    category: Category.Drug,
    displayName: 'Enalapril',
    name: AllergyName.Enalapril,
  },
  [AllergyName.Ertapenem]: {
    category: Category.Drug,
    displayName: 'Ertapenem',
    name: AllergyName.Ertapenem,
  },
  [AllergyName.Erythromycin]: {
    category: Category.Drug,
    displayName: 'Erythromycin',
    name: AllergyName.Erythromycin,
  },
  [AllergyName.Etomidate]: {
    category: Category.Drug,
    displayName: 'Etomidate',
    name: AllergyName.Etomidate,
  },
  [AllergyName.Fentanyl]: {
    category: Category.Drug,
    displayName: 'Fentanyl',
    name: AllergyName.Fentanyl,
  },
  [AllergyName.Fish]: {
    category: Category.Food,
    displayName: 'Fish',
    name: AllergyName.Fish,
  },
  [AllergyName.Furosemide]: {
    category: Category.Drug,
    displayName: 'Furosemide',
    name: AllergyName.Furosemide,
  },
  [AllergyName.Gabapentin]: {
    category: Category.Drug,
    displayName: 'Gabapentin',
    name: AllergyName.Gabapentin,
  },
  [AllergyName.Gentamicin]: {
    category: Category.Drug,
    displayName: 'Gentamicin',
    name: AllergyName.Gentamicin,
  },
  [AllergyName.Gluten]: {
    category: Category.Food,
    displayName: 'Gluten',
    name: AllergyName.Gluten,
  },
  [AllergyName.Haldol]: {
    category: Category.Drug,
    displayName: 'Haldol',
    name: AllergyName.Haldol,
  },
  [AllergyName.Hydrocodone]: {
    category: Category.Drug,
    displayName: 'Hydrocodone',
    name: AllergyName.Hydrocodone,
  },
  [AllergyName.Hydrocortisone]: {
    category: Category.Drug,
    displayName: 'Hydrocortisone',
    name: AllergyName.Hydrocortisone,
  },
  [AllergyName.Hydromorphone]: {
    category: Category.Drug,
    displayName: 'Hydromorphone',
    name: AllergyName.Hydromorphone,
  },
  [AllergyName.Ibuprofen]: {
    category: Category.Drug,
    displayName: 'Ibuprofen',
    name: AllergyName.Ibuprofen,
  },
  [AllergyName.Imipenem]: {
    category: Category.Drug,
    displayName: 'Imipenem',
    name: AllergyName.Imipenem,
  },
  [AllergyName.Indomethacin]: {
    category: Category.Drug,
    displayName: 'Indomethacin',
    name: AllergyName.Indomethacin,
  },
  [AllergyName.Insulin]: {
    category: Category.Drug,
    displayName: 'Insulin',
    name: AllergyName.Insulin,
  },
  [AllergyName.IodinatedContrast]: {
    category: Category.Drug,
    displayName: 'Iodinated_contrast',
    name: AllergyName.IodinatedContrast,
  },
  [AllergyName.Iodine]: {
    category: Category.Drug,
    displayName: 'Iodine',
    name: AllergyName.Iodine,
  },
  [AllergyName.Keflex]: {
    category: Category.Drug,
    displayName: 'Keflex',
    name: AllergyName.Keflex,
  },
  [AllergyName.Ketamine]: {
    category: Category.Drug,
    displayName: 'Ketamine',
    name: AllergyName.Ketamine,
  },
  [AllergyName.Labetalol]: {
    category: Category.Drug,
    displayName: 'Labetalol',
    name: AllergyName.Labetalol,
  },
  [AllergyName.Lactose]: {
    category: Category.Food,
    displayName: 'Lactose',
    name: AllergyName.Lactose,
  },
  [AllergyName.Latex]: {
    category: Category.Environment,
    displayName: 'Latex',
    name: AllergyName.Latex,
  },
  [AllergyName.LevofloxacinLevaquin]: {
    category: Category.Drug,
    displayName: 'Levofloxacin (Levaquin)',
    name: AllergyName.LevofloxacinLevaquin,
  },
  [AllergyName.Lidocaine]: {
    category: Category.Drug,
    displayName: 'Lidocaine',
    name: AllergyName.Lidocaine,
  },
  [AllergyName.Linezolid]: {
    category: Category.Drug,
    displayName: 'Linezolid',
    name: AllergyName.Linezolid,
  },
  [AllergyName.Lisinopril]: {
    category: Category.Drug,
    displayName: 'Lisinopril',
    name: AllergyName.Lisinopril,
  },
  [AllergyName.Lorazepam]: {
    category: Category.Drug,
    displayName: 'Lorazepam',
    name: AllergyName.Lorazepam,
  },
  [AllergyName.Losartan]: {
    category: Category.Drug,
    displayName: 'Losartan',
    name: AllergyName.Losartan,
  },
  [AllergyName.Lovastatin]: {
    category: Category.Drug,
    displayName: 'Lovastatin',
    name: AllergyName.Lovastatin,
  },
  [AllergyName.Mannitol]: {
    category: Category.Drug,
    displayName: 'Mannitol',
    name: AllergyName.Mannitol,
  },
  [AllergyName.Meperidine]: {
    category: Category.Drug,
    displayName: 'Meperidine',
    name: AllergyName.Meperidine,
  },
  [AllergyName.Meropenem]: {
    category: Category.Drug,
    displayName: 'Meropenem',
    name: AllergyName.Meropenem,
  },
  [AllergyName.Methylprednisolone]: {
    category: Category.Drug,
    displayName: 'Methylprednisolone',
    name: AllergyName.Methylprednisolone,
  },
  [AllergyName.Metoclopramide]: {
    category: Category.Drug,
    displayName: 'Metoclopramide',
    name: AllergyName.Metoclopramide,
  },
  [AllergyName.Metoprolol]: {
    category: Category.Drug,
    displayName: 'Metoprolol',
    name: AllergyName.Metoprolol,
  },
  [AllergyName.Metronidazole]: {
    category: Category.Drug,
    displayName: 'Metronidazole',
    name: AllergyName.Metronidazole,
  },
  [AllergyName.Midazolam]: {
    category: Category.Drug,
    displayName: 'Midazolam',
    name: AllergyName.Midazolam,
  },
  [AllergyName.Minocycline]: {
    category: Category.Drug,
    displayName: 'Minocycline',
    name: AllergyName.Minocycline,
  },
  [AllergyName.Morphine]: {
    category: Category.Drug,
    displayName: 'Morphine',
    name: AllergyName.Morphine,
  },
  [AllergyName.Moxifloxacin]: {
    category: Category.Drug,
    displayName: 'Moxifloxacin',
    name: AllergyName.Moxifloxacin,
  },
  [AllergyName.Naproxen]: {
    category: Category.Drug,
    displayName: 'Naproxen',
    name: AllergyName.Naproxen,
  },
  [AllergyName.Nitrofurantoin]: {
    category: Category.Drug,
    displayName: 'Nitrofurantoin',
    name: AllergyName.Nitrofurantoin,
  },
  [AllergyName.Nsaids]: {
    category: Category.Drug,
    displayName: 'Nsaids',
    name: AllergyName.Nsaids,
  },
  [AllergyName.Ofloxacin]: {
    category: Category.Drug,
    displayName: 'Ofloxacin',
    name: AllergyName.Ofloxacin,
  },
  [AllergyName.Ondansetron]: {
    category: Category.Drug,
    displayName: 'Ondansetron',
    name: AllergyName.Ondansetron,
  },
  [AllergyName.Other]: {
    category: Category.Drug,
    displayName: 'Other',
    name: AllergyName.Other,
  },
  [AllergyName.Oxycodone]: {
    category: Category.Drug,
    displayName: 'Oxycodone',
    name: AllergyName.Oxycodone,
  },
  [AllergyName.Pancuronium]: {
    category: Category.Drug,
    displayName: 'Pancuronium',
    name: AllergyName.Pancuronium,
  },
  [AllergyName.Peanut]: {
    category: Category.Food,
    displayName: 'Peanut',
    name: AllergyName.Peanut,
  },
  [AllergyName.Penicillin]: {
    category: Category.Drug,
    displayName: 'Penicillin',
    name: AllergyName.Penicillin,
  },
  [AllergyName.Percocet]: {
    category: Category.Drug,
    displayName: 'Percocet',
    name: AllergyName.Percocet,
  },
  [AllergyName.Prednisolone]: {
    category: Category.Drug,
    displayName: 'Prednisolone',
    name: AllergyName.Prednisolone,
  },
  [AllergyName.Prednisone]: {
    category: Category.Drug,
    displayName: 'Prednisone',
    name: AllergyName.Prednisone,
  },
  [AllergyName.Pregabalin]: {
    category: Category.Drug,
    displayName: 'Pregabalin',
    name: AllergyName.Pregabalin,
  },
  [AllergyName.Procaine]: {
    category: Category.Drug,
    displayName: 'Procaine',
    name: AllergyName.Procaine,
  },
  [AllergyName.Promethazine]: {
    category: Category.Drug,
    displayName: 'Promethazine',
    name: AllergyName.Promethazine,
  },
  [AllergyName.Propofol]: {
    category: Category.Drug,
    displayName: 'Propofol',
    name: AllergyName.Propofol,
  },
  [AllergyName.Ramipril]: {
    category: Category.Drug,
    displayName: 'Ramipril',
    name: AllergyName.Ramipril,
  },
  [AllergyName.Rocuronium]: {
    category: Category.Drug,
    displayName: 'Rocuronium',
    name: AllergyName.Rocuronium,
  },
  [AllergyName.Ropivacaine]: {
    category: Category.Drug,
    displayName: 'Ropivacaine',
    name: AllergyName.Ropivacaine,
  },
  [AllergyName.Scopolamine]: {
    category: Category.Drug,
    displayName: 'Scopolamine',
    name: AllergyName.Scopolamine,
  },
  [AllergyName.Shellfish]: {
    category: Category.Food,
    displayName: 'Shellfish',
    name: AllergyName.Shellfish,
  },
  [AllergyName.Simvastatin]: {
    category: Category.Drug,
    displayName: 'Simvastatin',
    name: AllergyName.Simvastatin,
  },
  [AllergyName.Soy]: {
    category: Category.Food,
    displayName: 'Soy',
    name: AllergyName.Soy,
  },
  [AllergyName.Succinylcholine]: {
    category: Category.Drug,
    displayName: 'Succinylcholine',
    name: AllergyName.Succinylcholine,
  },
  [AllergyName.Sulfamethoxazole]: {
    category: Category.Drug,
    displayName: 'Sulfamethoxazole',
    name: AllergyName.Sulfamethoxazole,
  },
  [AllergyName.SulfaMedications]: {
    category: Category.Drug,
    displayName: 'Sulfa Medications',
    name: AllergyName.SulfaMedications,
  },
  [AllergyName.Tetracycline]: {
    category: Category.Drug,
    displayName: 'Tetracycline',
    name: AllergyName.Tetracycline,
  },
  [AllergyName.Tobramycin]: {
    category: Category.Drug,
    displayName: 'Tobramycin',
    name: AllergyName.Tobramycin,
  },
  [AllergyName.Toradol]: {
    category: Category.Drug,
    displayName: 'Toradol',
    name: AllergyName.Toradol,
  },
  [AllergyName.Tramadol]: {
    category: Category.Drug,
    displayName: 'Tramadol',
    name: AllergyName.Tramadol,
  },
  [AllergyName.Trimethoprim]: {
    category: Category.Drug,
    displayName: 'Trimethoprim',
    name: AllergyName.Trimethoprim,
  },
  [AllergyName.Valsartan]: {
    category: Category.Drug,
    displayName: 'Valsartan',
    name: AllergyName.Valsartan,
  },
  [AllergyName.Vancomycin]: {
    category: Category.Drug,
    displayName: 'Vancomycin',
    name: AllergyName.Vancomycin,
  },
  [AllergyName.Vecuronium]: {
    category: Category.Drug,
    displayName: 'Vecuronium',
    name: AllergyName.Vecuronium,
  },
  [AllergyName.Wheat]: {
    category: Category.Food,
    displayName: 'Wheat',
    name: AllergyName.Wheat,
  },
  [AllergyName.Adhesive]: {
    category: Category.Environment,
    displayName: 'Adhesive',
    name: AllergyName.Adhesive,
  },
  [AllergyName.AcetaminophenCodeine]: {
    category: Category.Drug,
    displayName: 'Acetaminophen-Codeine',
    name: AllergyName.AcetaminophenCodeine,
  },
  [AllergyName.AcetaminophenDiphenhydramine]: {
    category: Category.Drug,
    displayName: 'Acetaminophen-Diphenhydramine',
    name: AllergyName.AcetaminophenDiphenhydramine,
  },
  [AllergyName.AcetaminophenHydrocodone]: {
    category: Category.Drug,
    displayName: 'Acetaminophen-Hydrocodone',
    name: AllergyName.AcetaminophenHydrocodone,
  },
  [AllergyName.AcetaminophenOxycodone]: {
    category: Category.Drug,
    displayName: 'Acetaminophen-Oxycodone',
    name: AllergyName.AcetaminophenOxycodone,
  },
  [AllergyName.AcetaminophenPropoxyphene]: {
    category: Category.Drug,
    displayName: 'Acetaminophen-Propoxyphene',
    name: AllergyName.AcetaminophenPropoxyphene,
  },
  [AllergyName.AcetaminophenTramadol]: {
    category: Category.Drug,
    displayName: 'Acetaminophen-Tramadol',
    name: AllergyName.AcetaminophenTramadol,
  },
  [AllergyName.AcetaminophenAspirinCaffeine]: {
    category: Category.Drug,
    displayName: 'Excedrin',
    name: AllergyName.AcetaminophenAspirinCaffeine,
  },
  [AllergyName.AcetaminophenDextromethorphanDoxylaminePse]: {
    category: Category.Drug,
    displayName: 'Nyquil',
    name: AllergyName.AcetaminophenDextromethorphanDoxylaminePse,
  },
  [AllergyName.Acetazolamide]: {
    category: Category.Drug,
    displayName: 'Acetazolamide',
    name: AllergyName.Acetazolamide,
  },
  [AllergyName.Acyclovir]: {
    category: Category.Drug,
    displayName: 'Acyclovir',
    name: AllergyName.Acyclovir,
  },
  [AllergyName.Adalimumab]: {
    category: Category.Drug,
    displayName: 'Adalimumab',
    name: AllergyName.Adalimumab,
  },
  [AllergyName.AdhesiveBandage]: {
    category: Category.Environment,
    displayName: 'Adhesive Bandage',
    name: AllergyName.AdhesiveBandage,
  },
  [AllergyName.Albuterol]: {
    category: Category.Drug,
    displayName: 'Albuterol',
    name: AllergyName.Albuterol,
  },
  [AllergyName.AlbuterolIpratropium]: {
    category: Category.Drug,
    displayName: 'Albuterol-Ipratropium',
    name: AllergyName.AlbuterolIpratropium,
  },
  [AllergyName.Alendronate]: {
    category: Category.Drug,
    displayName: 'Alendronate',
    name: AllergyName.Alendronate,
  },
  [AllergyName.Allopurinol]: {
    category: Category.Drug,
    displayName: 'Allopurinol',
    name: AllergyName.Allopurinol,
  },
  [AllergyName.AloeVera]: {
    category: Category.Drug,
    displayName: 'Aloe Vera',
    name: AllergyName.AloeVera,
  },
  [AllergyName.Amantadine]: {
    category: Category.Drug,
    displayName: 'Amantadine',
    name: AllergyName.Amantadine,
  },
  [AllergyName.Amiodarone]: {
    category: Category.Drug,
    displayName: 'Amiodarone',
    name: AllergyName.Amiodarone,
  },
  [AllergyName.Amitriptyline]: {
    category: Category.Drug,
    displayName: 'Amitriptyline',
    name: AllergyName.Amitriptyline,
  },
  [AllergyName.Amlodipine]: {
    category: Category.Drug,
    displayName: 'Amlodipine',
    name: AllergyName.Amlodipine,
  },
  [AllergyName.AmlodipineBenazepril]: {
    category: Category.Drug,
    displayName: 'Amlodipine-Benazepril',
    name: AllergyName.AmlodipineBenazepril,
  },
  [AllergyName.AmphetamineDextroamphetamine]: {
    category: Category.Drug,
    displayName: 'Amphetamine-Dextroamphetamine',
    name: AllergyName.AmphetamineDextroamphetamine,
  },
  [AllergyName.AmpicillinSulbactam]: {
    category: Category.Drug,
    displayName: 'Ampicillin-Sulbactam',
    name: AllergyName.AmpicillinSulbactam,
  },
  [AllergyName.Anastrozole]: {
    category: Category.Drug,
    displayName: 'Anastrozole',
    name: AllergyName.Anastrozole,
  },
  [AllergyName.AnimalDander]: {
    category: Category.Drug,
    displayName: 'Animal Dander',
    name: AllergyName.AnimalDander,
  },
  [AllergyName.ApapDichloralphenazoneIsometheptene]: {
    category: Category.Drug,
    displayName: 'Midrin',
    name: AllergyName.ApapDichloralphenazoneIsometheptene,
  },
  [AllergyName.Apixaban]: {
    category: Category.Drug,
    displayName: 'Apixaban',
    name: AllergyName.Apixaban,
  },
  [AllergyName.AppleJuice]: {
    category: Category.Food,
    displayName: 'Apple Juice',
    name: AllergyName.AppleJuice,
  },
  [AllergyName.Aripiprazole]: {
    category: Category.Drug,
    displayName: 'Aripiprazole',
    name: AllergyName.Aripiprazole,
  },
  [AllergyName.AscorbicAcid]: {
    category: Category.Drug,
    displayName: 'Ascorbic Acid',
    name: AllergyName.AscorbicAcid,
  },
  [AllergyName.Aspartame]: {
    category: Category.Food,
    displayName: 'Aspartame',
    name: AllergyName.Aspartame,
  },
  [AllergyName.AspirinDipyridamole]: {
    category: Category.Drug,
    displayName: 'Aspirin-Dipyridamole',
    name: AllergyName.AspirinDipyridamole,
  },
  [AllergyName.AspirinOxycodone]: {
    category: Category.Drug,
    displayName: 'Aspirin-Oxycodone',
    name: AllergyName.AspirinOxycodone,
  },
  [AllergyName.AspirinButalbitalCaffeine]: {
    category: Category.Drug,
    displayName: 'Fiorinal',
    name: AllergyName.AspirinButalbitalCaffeine,
  },
  [AllergyName.Atenolol]: {
    category: Category.Drug,
    displayName: 'Atenolol',
    name: AllergyName.Atenolol,
  },
  [AllergyName.Atomoxetine]: {
    category: Category.Drug,
    displayName: 'Atomoxetine',
    name: AllergyName.Atomoxetine,
  },
  [AllergyName.Atropine]: {
    category: Category.Drug,
    displayName: 'Atropine',
    name: AllergyName.Atropine,
  },
  [AllergyName.AtropineDiphenoxylate]: {
    category: Category.Drug,
    displayName: 'Atropine-Diphenoxylate',
    name: AllergyName.AtropineDiphenoxylate,
  },
  [AllergyName.AtropineHyoscyaminePbScopolamine]: {
    category: Category.Drug,
    displayName: 'Donnatal',
    name: AllergyName.AtropineHyoscyaminePbScopolamine,
  },
  [AllergyName.Azathioprine]: {
    category: Category.Drug,
    displayName: 'Azathioprine',
    name: AllergyName.Azathioprine,
  },
  [AllergyName.Bacitracin]: {
    category: Category.Drug,
    displayName: 'Bacitracin',
    name: AllergyName.Bacitracin,
  },
  [AllergyName.BacitracinPolymyxinBTopical]: {
    category: Category.Drug,
    displayName: 'Bacitracin-Polymyxin B Topical',
    name: AllergyName.BacitracinPolymyxinBTopical,
  },
  [AllergyName.BacitracinNeomycinPolymyxinBTopical]: {
    category: Category.Drug,
    displayName: 'Neosporin',
    name: AllergyName.BacitracinNeomycinPolymyxinBTopical,
  },
  [AllergyName.Baclofen]: {
    category: Category.Drug,
    displayName: 'Baclofen',
    name: AllergyName.Baclofen,
  },
  [AllergyName.Banana]: {
    category: Category.Food,
    displayName: 'Banana',
    name: AllergyName.Banana,
  },
  [AllergyName.BariumSulfate]: {
    category: Category.Drug,
    displayName: 'Barium Sulfate',
    name: AllergyName.BariumSulfate,
  },
  [AllergyName.BeePollen]: {
    category: Category.Environment,
    displayName: 'Bee Pollen',
    name: AllergyName.BeePollen,
  },
  [AllergyName.BeeStings]: {
    category: Category.Environment,
    displayName: 'Bee Stings',
    name: AllergyName.BeeStings,
  },
  [AllergyName.Benazepril]: {
    category: Category.Drug,
    displayName: 'Benazepril',
    name: AllergyName.Benazepril,
  },
  [AllergyName.Benzocaine]: {
    category: Category.Drug,
    displayName: 'Benzocaine',
    name: AllergyName.Benzocaine,
  },
  [AllergyName.BenzoinTopical]: {
    category: Category.Drug,
    displayName: 'Benzoin Topical',
    name: AllergyName.BenzoinTopical,
  },
  [AllergyName.Benzonatate]: {
    category: Category.Drug,
    displayName: 'Benzonatate',
    name: AllergyName.Benzonatate,
  },
  [AllergyName.BenzoylPeroxideTopical]: {
    category: Category.Drug,
    displayName: 'Benzoyl Peroxide Topical',
    name: AllergyName.BenzoylPeroxideTopical,
  },
  [AllergyName.Benztropine]: {
    category: Category.Drug,
    displayName: 'Benztropine',
    name: AllergyName.Benztropine,
  },
  [AllergyName.BismuthSubsalicylate]: {
    category: Category.Drug,
    displayName: 'Bismuth Subsalicylate',
    name: AllergyName.BismuthSubsalicylate,
  },
  [AllergyName.BrimonidineOphthalmic]: {
    category: Category.Drug,
    displayName: 'Brimonidine Ophthalmic',
    name: AllergyName.BrimonidineOphthalmic,
  },
  [AllergyName.BrimonidineTimololOphthalmic]: {
    category: Category.Drug,
    displayName: 'Brimonidine-Timolol Ophthalmic',
    name: AllergyName.BrimonidineTimololOphthalmic,
  },
  [AllergyName.BudesonideNasal]: {
    category: Category.Drug,
    displayName: 'Budesonide Nasal',
    name: AllergyName.BudesonideNasal,
  },
  [AllergyName.BudesonideFormoterol]: {
    category: Category.Drug,
    displayName: 'Budesonide-Formoterol',
    name: AllergyName.BudesonideFormoterol,
  },
  [AllergyName.Bumetanide]: {
    category: Category.Drug,
    displayName: 'Bumetanide',
    name: AllergyName.Bumetanide,
  },
  [AllergyName.Buprenorphine]: {
    category: Category.Drug,
    displayName: 'Buprenorphine',
    name: AllergyName.Buprenorphine,
  },
  [AllergyName.Bupropion]: {
    category: Category.Drug,
    displayName: 'Bupropion',
    name: AllergyName.Bupropion,
  },
  [AllergyName.Buspirone]: {
    category: Category.Drug,
    displayName: 'Buspirone',
    name: AllergyName.Buspirone,
  },
  [AllergyName.Butorphanol]: {
    category: Category.Drug,
    displayName: 'Butorphanol',
    name: AllergyName.Butorphanol,
  },
  [AllergyName.Caffeine]: {
    category: Category.Drug,
    displayName: 'Caffeine',
    name: AllergyName.Caffeine,
  },
  [AllergyName.CaffeineErgotamine]: {
    category: Category.Drug,
    displayName: 'Caffeine-Ergotamine',
    name: AllergyName.CaffeineErgotamine,
  },
  [AllergyName.Calcitonin]: {
    category: Category.Drug,
    displayName: 'Calcitonin',
    name: AllergyName.Calcitonin,
  },
  [AllergyName.CalciumCarbonate]: {
    category: Category.Drug,
    displayName: 'Calcium Carbonate',
    name: AllergyName.CalciumCarbonate,
  },
  [AllergyName.CamphorEucalyptusMentholTopical]: {
    category: Category.Drug,
    displayName: 'Pain relief cream/ointment',
    name: AllergyName.CamphorEucalyptusMentholTopical,
  },
  [AllergyName.Canagliflozin]: {
    category: Category.Drug,
    displayName: 'Canagliflozin',
    name: AllergyName.Canagliflozin,
  },
  [AllergyName.Candesartan]: {
    category: Category.Drug,
    displayName: 'Candesartan',
    name: AllergyName.Candesartan,
  },
  [AllergyName.Captopril]: {
    category: Category.Drug,
    displayName: 'Captopril',
    name: AllergyName.Captopril,
  },
  [AllergyName.Carbamazepine]: {
    category: Category.Drug,
    displayName: 'Carbamazepine',
    name: AllergyName.Carbamazepine,
  },
  [AllergyName.CarbidopaLevodopa]: {
    category: Category.Drug,
    displayName: 'Carbidopa-Levodopa',
    name: AllergyName.CarbidopaLevodopa,
  },
  [AllergyName.Carboplatin]: {
    category: Category.Drug,
    displayName: 'Carboplatin',
    name: AllergyName.Carboplatin,
  },
  [AllergyName.CarboxymethylcelluloseOphthalmic]: {
    category: Category.Drug,
    displayName: 'Carboxymethylcellulose Ophthalmic',
    name: AllergyName.CarboxymethylcelluloseOphthalmic,
  },
  [AllergyName.Carisoprodol]: {
    category: Category.Drug,
    displayName: 'Carisoprodol',
    name: AllergyName.Carisoprodol,
  },
  [AllergyName.Carvedilol]: {
    category: Category.Drug,
    displayName: 'Carvedilol',
    name: AllergyName.Carvedilol,
  },
  [AllergyName.Cats]: {
    category: Category.Environment,
    displayName: 'Cats',
    name: AllergyName.Cats,
  },
  [AllergyName.Cefaclor]: {
    category: Category.Drug,
    displayName: 'Cefaclor',
    name: AllergyName.Cefaclor,
  },
  [AllergyName.Cefadroxil]: {
    category: Category.Drug,
    displayName: 'Cefadroxil',
    name: AllergyName.Cefadroxil,
  },
  [AllergyName.Cefepime]: {
    category: Category.Drug,
    displayName: 'Cefepime',
    name: AllergyName.Cefepime,
  },
  [AllergyName.Cefixime]: {
    category: Category.Drug,
    displayName: 'Cefixime',
    name: AllergyName.Cefixime,
  },
  [AllergyName.Cefoxitin]: {
    category: Category.Drug,
    displayName: 'Cefoxitin',
    name: AllergyName.Cefoxitin,
  },
  [AllergyName.Cefpodoxime]: {
    category: Category.Drug,
    displayName: 'Cefpodoxime',
    name: AllergyName.Cefpodoxime,
  },
  [AllergyName.Cefprozil]: {
    category: Category.Drug,
    displayName: 'Cefprozil',
    name: AllergyName.Cefprozil,
  },
  [AllergyName.Cetirizine]: {
    category: Category.Drug,
    displayName: 'Cetirizine',
    name: AllergyName.Cetirizine,
  },
  [AllergyName.Cherry]: {
    category: Category.Food,
    displayName: 'Cherry',
    name: AllergyName.Cherry,
  },
  [AllergyName.ChlorhexidineTopical]: {
    category: Category.Drug,
    displayName: 'Chlorhexidine Topical',
    name: AllergyName.ChlorhexidineTopical,
  },
  [AllergyName.ChlorpheniramineHydrocodone]: {
    category: Category.Drug,
    displayName: 'Chlorpheniramine-Hydrocodone',
    name: AllergyName.ChlorpheniramineHydrocodone,
  },
  [AllergyName.ChlorpheniraminePseudoephedrine]: {
    category: Category.Drug,
    displayName: 'Chlorpheniramine-Pseudoephedrine',
    name: AllergyName.ChlorpheniraminePseudoephedrine,
  },
  [AllergyName.Chlorpromazine]: {
    category: Category.Drug,
    displayName: 'Chlorpromazine',
    name: AllergyName.Chlorpromazine,
  },
  [AllergyName.Chlorthalidone]: {
    category: Category.Drug,
    displayName: 'Chlorthalidone',
    name: AllergyName.Chlorthalidone,
  },
  [AllergyName.Chlorzoxazone]: {
    category: Category.Drug,
    displayName: 'Chlorzoxazone',
    name: AllergyName.Chlorzoxazone,
  },
  [AllergyName.Chocolate]: {
    category: Category.Food,
    displayName: 'Chocolate',
    name: AllergyName.Chocolate,
  },
  [AllergyName.Cholestyramine]: {
    category: Category.Drug,
    displayName: 'Cholestyramine',
    name: AllergyName.Cholestyramine,
  },
  [AllergyName.ChondroitinGlucosamine]: {
    category: Category.Drug,
    displayName: 'Chondroitin-Glucosamine',
    name: AllergyName.ChondroitinGlucosamine,
  },
  [AllergyName.Cilostazol]: {
    category: Category.Drug,
    displayName: 'Cilostazol',
    name: AllergyName.Cilostazol,
  },
  [AllergyName.Cimetidine]: {
    category: Category.Drug,
    displayName: 'Cimetidine',
    name: AllergyName.Cimetidine,
  },
  [AllergyName.Cinnamon]: {
    category: Category.Food,
    displayName: 'Cinnamon',
    name: AllergyName.Cinnamon,
  },
  [AllergyName.Citalopram]: {
    category: Category.Drug,
    displayName: 'Citalopram',
    name: AllergyName.Citalopram,
  },
  [AllergyName.CitricAcid]: {
    category: Category.Food,
    displayName: 'Citric Acid',
    name: AllergyName.CitricAcid,
  },
  [AllergyName.Clavulanate]: {
    category: Category.Drug,
    displayName: 'Clavulanate',
    name: AllergyName.Clavulanate,
  },
  [AllergyName.ClobetasolTopical]: {
    category: Category.Drug,
    displayName: 'Clobetasol Topical',
    name: AllergyName.ClobetasolTopical,
  },
  [AllergyName.Clonazepam]: {
    category: Category.Drug,
    displayName: 'Clonazepam',
    name: AllergyName.Clonazepam,
  },
  [AllergyName.Clonidine]: {
    category: Category.Drug,
    displayName: 'Clonidine',
    name: AllergyName.Clonidine,
  },
  [AllergyName.Clopidogrel]: {
    category: Category.Drug,
    displayName: 'Clopidogrel',
    name: AllergyName.Clopidogrel,
  },
  [AllergyName.Clotrimazole]: {
    category: Category.Drug,
    displayName: 'Clotrimazole',
    name: AllergyName.Clotrimazole,
  },
  [AllergyName.CoconutOil]: {
    category: Category.Food,
    displayName: 'Coconut Oil',
    name: AllergyName.CoconutOil,
  },
  [AllergyName.CodeineGuaifenesin]: {
    category: Category.Drug,
    displayName: 'Codeine-Guaifenesin',
    name: AllergyName.CodeineGuaifenesin,
  },
  [AllergyName.Colchicine]: {
    category: Category.Drug,
    displayName: 'Colchicine',
    name: AllergyName.Colchicine,
  },
  [AllergyName.Colesevelam]: {
    category: Category.Drug,
    displayName: 'Colesevelam',
    name: AllergyName.Colesevelam,
  },
  [AllergyName.Colestipol]: {
    category: Category.Drug,
    displayName: 'Colestipol',
    name: AllergyName.Colestipol,
  },
  [AllergyName.ConjugatedEstrogens]: {
    category: Category.Drug,
    displayName: 'Conjugated Estrogens',
    name: AllergyName.ConjugatedEstrogens,
  },
  [AllergyName.CopperChloride]: {
    category: Category.Drug,
    displayName: 'Copper Chloride',
    name: AllergyName.CopperChloride,
  },
  [AllergyName.Corn]: {
    category: Category.Food,
    displayName: 'Corn',
    name: AllergyName.Corn,
  },
  [AllergyName.Cranberry]: {
    category: Category.Food,
    displayName: 'Cranberry',
    name: AllergyName.Cranberry,
  },
  [AllergyName.Dandelion]: {
    category: Category.Environment,
    displayName: 'Dandelion',
    name: AllergyName.Dandelion,
  },
  [AllergyName.Dapagliflozin]: {
    category: Category.Drug,
    displayName: 'Dapagliflozin',
    name: AllergyName.Dapagliflozin,
  },
  [AllergyName.Dapsone]: {
    category: Category.Drug,
    displayName: 'Dapsone',
    name: AllergyName.Dapsone,
  },
  [AllergyName.Desipramine]: {
    category: Category.Drug,
    displayName: 'Desipramine',
    name: AllergyName.Desipramine,
  },
  [AllergyName.Desvenlafaxine]: {
    category: Category.Drug,
    displayName: 'Desvenlafaxine',
    name: AllergyName.Desvenlafaxine,
  },
  [AllergyName.DexamethasoneNeomycinPolymyxinBOphthalmic]: {
    category: Category.Drug,
    displayName: 'Maxitrol',
    name: AllergyName.DexamethasoneNeomycinPolymyxinBOphthalmic,
  },
  [AllergyName.Dexlansoprazole]: {
    category: Category.Drug,
    displayName: 'Dexlansoprazole',
    name: AllergyName.Dexlansoprazole,
  },
  [AllergyName.Dexmethylphenidate]: {
    category: Category.Drug,
    displayName: 'Dexmethylphenidate',
    name: AllergyName.Dexmethylphenidate,
  },
  [AllergyName.Dextromethorphan]: {
    category: Category.Drug,
    displayName: 'Dextromethorphan',
    name: AllergyName.Dextromethorphan,
  },
  [AllergyName.DextromethorphanDoxylamine]: {
    category: Category.Drug,
    displayName: 'Dextromethorphan-Doxylamine',
    name: AllergyName.DextromethorphanDoxylamine,
  },
  [AllergyName.DextromethorphanGuaifenesin]: {
    category: Category.Drug,
    displayName: 'Dextromethorphan-Guaifenesin',
    name: AllergyName.DextromethorphanGuaifenesin,
  },
  [AllergyName.Diclofenac]: {
    category: Category.Drug,
    displayName: 'Diclofenac',
    name: AllergyName.Diclofenac,
  },
  [AllergyName.DiclofenacMisoprostol]: {
    category: Category.Drug,
    displayName: 'Diclofenac-Misoprostol',
    name: AllergyName.DiclofenacMisoprostol,
  },
  [AllergyName.Dicloxacillin]: {
    category: Category.Drug,
    displayName: 'Dicloxacillin',
    name: AllergyName.Dicloxacillin,
  },
  [AllergyName.Dicyclomine]: {
    category: Category.Drug,
    displayName: 'Dicyclomine',
    name: AllergyName.Dicyclomine,
  },
  [AllergyName.Diflunisal]: {
    category: Category.Drug,
    displayName: 'Diflunisal',
    name: AllergyName.Diflunisal,
  },
  [AllergyName.Digoxin]: {
    category: Category.Drug,
    displayName: 'Digoxin',
    name: AllergyName.Digoxin,
  },
  [AllergyName.Dihydroergotamine]: {
    category: Category.Drug,
    displayName: 'Dihydroergotamine',
    name: AllergyName.Dihydroergotamine,
  },
  [AllergyName.Diltiazem]: {
    category: Category.Drug,
    displayName: 'Diltiazem',
    name: AllergyName.Diltiazem,
  },
  [AllergyName.Disulfiram]: {
    category: Category.Drug,
    displayName: 'Disulfiram',
    name: AllergyName.Disulfiram,
  },
  [AllergyName.Dogs]: {
    category: Category.Environment,
    displayName: 'Dogs',
    name: AllergyName.Dogs,
  },
  [AllergyName.Donepezil]: {
    category: Category.Drug,
    displayName: 'Donepezil',
    name: AllergyName.Donepezil,
  },
  [AllergyName.DorzolamideOphthalmic]: {
    category: Category.Drug,
    displayName: 'Dorzolamide Ophthalmic',
    name: AllergyName.DorzolamideOphthalmic,
  },
  [AllergyName.DorzolamideTimololOphthalmic]: {
    category: Category.Drug,
    displayName: 'Dorzolamide-Timolol Ophthalmic',
    name: AllergyName.DorzolamideTimololOphthalmic,
  },
  [AllergyName.Doxazosin]: {
    category: Category.Drug,
    displayName: 'Doxazosin',
    name: AllergyName.Doxazosin,
  },
  [AllergyName.Doxepin]: {
    category: Category.Drug,
    displayName: 'Doxepin',
    name: AllergyName.Doxepin,
  },
  [AllergyName.Dronedarone]: {
    category: Category.Drug,
    displayName: 'Dronedarone',
    name: AllergyName.Dronedarone,
  },
  [AllergyName.Droperidol]: {
    category: Category.Drug,
    displayName: 'Droperidol',
    name: AllergyName.Droperidol,
  },
  [AllergyName.DrospirenoneEthinylEstradiol]: {
    category: Category.Drug,
    displayName: 'Drospirenone-Ethinyl Estradiol',
    name: AllergyName.DrospirenoneEthinylEstradiol,
  },
  [AllergyName.Dulaglutide]: {
    category: Category.Drug,
    displayName: 'Dulaglutide',
    name: AllergyName.Dulaglutide,
  },
  [AllergyName.Duloxetine]: {
    category: Category.Drug,
    displayName: 'Duloxetine',
    name: AllergyName.Duloxetine,
  },
  [AllergyName.Dust]: {
    category: Category.Environment,
    displayName: 'Dust',
    name: AllergyName.Dust,
  },
  [AllergyName.Eletriptan]: {
    category: Category.Drug,
    displayName: 'Eletriptan',
    name: AllergyName.Eletriptan,
  },
  [AllergyName.Empagliflozin]: {
    category: Category.Drug,
    displayName: 'Empagliflozin',
    name: AllergyName.Empagliflozin,
  },
  [AllergyName.Enoxaparin]: {
    category: Category.Drug,
    displayName: 'Enoxaparin',
    name: AllergyName.Enoxaparin,
  },
  [AllergyName.Ephedrine]: {
    category: Category.Drug,
    displayName: 'Ephedrine',
    name: AllergyName.Ephedrine,
  },
  [AllergyName.Epinephrine]: {
    category: Category.Drug,
    displayName: 'Epinephrine',
    name: AllergyName.Epinephrine,
  },
  [AllergyName.EpinephrineLidocaine]: {
    category: Category.Drug,
    displayName: 'Epinephrine-Lidocaine',
    name: AllergyName.EpinephrineLidocaine,
  },
  [AllergyName.ErythromycinSulfisoxazole]: {
    category: Category.Drug,
    displayName: 'Erythromycin-Sulfisoxazole',
    name: AllergyName.ErythromycinSulfisoxazole,
  },
  [AllergyName.Escitalopram]: {
    category: Category.Drug,
    displayName: 'Escitalopram',
    name: AllergyName.Escitalopram,
  },
  [AllergyName.Esomeprazole]: {
    category: Category.Drug,
    displayName: 'Esomeprazole',
    name: AllergyName.Esomeprazole,
  },
  [AllergyName.Estradiol]: {
    category: Category.Drug,
    displayName: 'Estradiol',
    name: AllergyName.Estradiol,
  },
  [AllergyName.Estrogens]: {
    category: Category.Drug,
    displayName: 'Estrogens',
    name: AllergyName.Estrogens,
  },
  [AllergyName.Eszopiclone]: {
    category: Category.Drug,
    displayName: 'Eszopiclone',
    name: AllergyName.Eszopiclone,
  },
  [AllergyName.Etanercept]: {
    category: Category.Drug,
    displayName: 'Etanercept',
    name: AllergyName.Etanercept,
  },
  [AllergyName.Ethanol]: {
    category: Category.Drug,
    displayName: 'Ethanol',
    name: AllergyName.Ethanol,
  },
  [AllergyName.EthinylEstradiol]: {
    category: Category.Drug,
    displayName: 'Ethinyl Estradiol',
    name: AllergyName.EthinylEstradiol,
  },
  [AllergyName.EthinylEstradiolLevonorgestrel]: {
    category: Category.Drug,
    displayName: 'Ethinyl Estradiol-Levonorgestrel',
    name: AllergyName.EthinylEstradiolLevonorgestrel,
  },
  [AllergyName.EthinylEstradiolNorelgestromin]: {
    category: Category.Drug,
    displayName: 'Ethinyl Estradiol-Norelgestromin',
    name: AllergyName.EthinylEstradiolNorelgestromin,
  },
  [AllergyName.EthinylEstradiolNorgestimate]: {
    category: Category.Drug,
    displayName: 'Ethinyl Estradiol-Norgestimate',
    name: AllergyName.EthinylEstradiolNorgestimate,
  },
  [AllergyName.Etodolac]: {
    category: Category.Drug,
    displayName: 'Etodolac',
    name: AllergyName.Etodolac,
  },
  [AllergyName.Exenatide]: {
    category: Category.Drug,
    displayName: 'Exenatide',
    name: AllergyName.Exenatide,
  },
  [AllergyName.Ezetimibe]: {
    category: Category.Drug,
    displayName: 'Ezetimibe',
    name: AllergyName.Ezetimibe,
  },
  [AllergyName.EzetimibeSimvastatin]: {
    category: Category.Drug,
    displayName: 'Ezetimibe-Simvastatin',
    name: AllergyName.EzetimibeSimvastatin,
  },
  [AllergyName.Famotidine]: {
    category: Category.Drug,
    displayName: 'Famotidine',
    name: AllergyName.Famotidine,
  },
  [AllergyName.Felodipine]: {
    category: Category.Drug,
    displayName: 'Felodipine',
    name: AllergyName.Felodipine,
  },
  [AllergyName.Fenofibrate]: {
    category: Category.Drug,
    displayName: 'Fenofibrate',
    name: AllergyName.Fenofibrate,
  },
  [AllergyName.FerrousSulfate]: {
    category: Category.Drug,
    displayName: 'Ferrous Sulfate',
    name: AllergyName.FerrousSulfate,
  },
  [AllergyName.Fexofenadine]: {
    category: Category.Drug,
    displayName: 'Fexofenadine',
    name: AllergyName.Fexofenadine,
  },
  [AllergyName.FexofenadinePseudoephedrine]: {
    category: Category.Drug,
    displayName: 'Fexofenadine-Pseudoephedrine',
    name: AllergyName.FexofenadinePseudoephedrine,
  },
  [AllergyName.Finasteride]: {
    category: Category.Drug,
    displayName: 'Finasteride',
    name: AllergyName.Finasteride,
  },
  [AllergyName.FishOil]: {
    category: Category.Drug,
    displayName: 'Fish Oil',
    name: AllergyName.FishOil,
  },
  [AllergyName.Flax]: {
    category: Category.Food,
    displayName: 'Flax',
    name: AllergyName.Flax,
  },
  [AllergyName.Flecainide]: {
    category: Category.Drug,
    displayName: 'Flecainide',
    name: AllergyName.Flecainide,
  },
  [AllergyName.Fluconazole]: {
    category: Category.Drug,
    displayName: 'Fluconazole',
    name: AllergyName.Fluconazole,
  },
  [AllergyName.Fluorescein]: {
    category: Category.Drug,
    displayName: 'Fluorescein',
    name: AllergyName.Fluorescein,
  },
  [AllergyName.FluorideContainingCompounds]: {
    category: Category.Environment,
    displayName: 'Fluoride Containing Compounds',
    name: AllergyName.FluorideContainingCompounds,
  },
  [AllergyName.Fluoxetine]: {
    category: Category.Drug,
    displayName: 'Fluoxetine',
    name: AllergyName.Fluoxetine,
  },
  [AllergyName.Fluphenazine]: {
    category: Category.Drug,
    displayName: 'Fluphenazine',
    name: AllergyName.Fluphenazine,
  },
  [AllergyName.Fluticasone]: {
    category: Category.Drug,
    displayName: 'Fluticasone',
    name: AllergyName.Fluticasone,
  },
  [AllergyName.FluticasoneSalmeterol]: {
    category: Category.Drug,
    displayName: 'Fluticasone-Salmeterol',
    name: AllergyName.FluticasoneSalmeterol,
  },
  [AllergyName.Fluvastatin]: {
    category: Category.Drug,
    displayName: 'Fluvastatin',
    name: AllergyName.Fluvastatin,
  },
  [AllergyName.Formaldehyde]: {
    category: Category.Drug,
    displayName: 'Formaldehyde',
    name: AllergyName.Formaldehyde,
  },
  [AllergyName.Fosinopril]: {
    category: Category.Drug,
    displayName: 'Fosinopril',
    name: AllergyName.Fosinopril,
  },
  [AllergyName.Fructose]: {
    category: Category.Food,
    displayName: 'Fructose',
    name: AllergyName.Fructose,
  },
  [AllergyName.GadoliniumContainingCompounds]: {
    category: Category.Environment,
    displayName: 'Gadolinium Containing Compounds',
    name: AllergyName.GadoliniumContainingCompounds,
  },
  [AllergyName.Garlic]: {
    category: Category.Food,
    displayName: 'Garlic',
    name: AllergyName.Garlic,
  },
  [AllergyName.Gatifloxacin]: {
    category: Category.Drug,
    displayName: 'Gatifloxacin',
    name: AllergyName.Gatifloxacin,
  },
  [AllergyName.Gemfibrozil]: {
    category: Category.Drug,
    displayName: 'Gemfibrozil',
    name: AllergyName.Gemfibrozil,
  },
  [AllergyName.Ginger]: {
    category: Category.Food,
    displayName: 'Ginger',
    name: AllergyName.Ginger,
  },
  [AllergyName.Glatiramer]: {
    category: Category.Drug,
    displayName: 'Glatiramer',
    name: AllergyName.Glatiramer,
  },
  [AllergyName.Glimepiride]: {
    category: Category.Drug,
    displayName: 'Glimepiride',
    name: AllergyName.Glimepiride,
  },
  [AllergyName.Glipizide]: {
    category: Category.Drug,
    displayName: 'Glipizide',
    name: AllergyName.Glipizide,
  },
  [AllergyName.Glucosamine]: {
    category: Category.Drug,
    displayName: 'Glucosamine',
    name: AllergyName.Glucosamine,
  },
  [AllergyName.Glucose]: {
    category: Category.Drug,
    displayName: 'Glucose',
    name: AllergyName.Glucose,
  },
  [AllergyName.Glyburide]: {
    category: Category.Drug,
    displayName: 'Glyburide',
    name: AllergyName.Glyburide,
  },
  [AllergyName.GoldContainingCompounds]: {
    category: Category.Environment,
    displayName: 'Gold Containing Compounds',
    name: AllergyName.GoldContainingCompounds,
  },
  [AllergyName.GramicidinNeomycinPolymyxinBOphthalmic]: {
    category: Category.Drug,
    displayName: 'Gramicidin/Neomycin/Polymyxin B Ophthalmic',
    name: AllergyName.GramicidinNeomycinPolymyxinBOphthalmic,
  },
  [AllergyName.Grass]: {
    category: Category.Environment,
    displayName: 'Grass',
    name: AllergyName.Grass,
  },
  [AllergyName.Griseofulvin]: {
    category: Category.Drug,
    displayName: 'Griseofulvin',
    name: AllergyName.Griseofulvin,
  },
  [AllergyName.Guaifenesin]: {
    category: Category.Drug,
    displayName: 'Guaifenesin',
    name: AllergyName.Guaifenesin,
  },
  [AllergyName.GuaifenesinPhenylephrine]: {
    category: Category.Drug,
    displayName: 'Guaifenesin-Phenylephrine',
    name: AllergyName.GuaifenesinPhenylephrine,
  },
  [AllergyName.GuaifenesinPseudoephedrine]: {
    category: Category.Drug,
    displayName: 'Guaifenesin-Pseudoephedrine',
    name: AllergyName.GuaifenesinPseudoephedrine,
  },
  [AllergyName.Guanfacine]: {
    category: Category.Drug,
    displayName: 'Guanfacine',
    name: AllergyName.Guanfacine,
  },
  [AllergyName.Haloperidol]: {
    category: Category.Drug,
    displayName: 'Haloperidol',
    name: AllergyName.Haloperidol,
  },
  [AllergyName.Hay]: {
    category: Category.Environment,
    displayName: 'Hay',
    name: AllergyName.Hay,
  },
  [AllergyName.Heparin]: {
    category: Category.Drug,
    displayName: 'Heparin',
    name: AllergyName.Heparin,
  },
  [AllergyName.HepatitisBVaccines]: {
    category: Category.Drug,
    displayName: 'Hepatitis B Vaccines',
    name: AllergyName.HepatitisBVaccines,
  },
  [AllergyName.Horses]: {
    category: Category.Environment,
    displayName: 'Horses',
    name: AllergyName.Horses,
  },
  [AllergyName.HouseDustMiteAllergenExtract]: {
    category: Category.Environment,
    displayName: 'House Dust Mite Allergen Extract',
    name: AllergyName.HouseDustMiteAllergenExtract,
  },
  [AllergyName.HumanPapillomavirusVaccine]: {
    category: Category.Drug,
    displayName: 'Human Papillomavirus Vaccine',
    name: AllergyName.HumanPapillomavirusVaccine,
  },
  [AllergyName.Hydralazine]: {
    category: Category.Drug,
    displayName: 'Hydralazine',
    name: AllergyName.Hydralazine,
  },
  [AllergyName.Hydrochlorothiazide]: {
    category: Category.Drug,
    displayName: 'Hydrochlorothiazide',
    name: AllergyName.Hydrochlorothiazide,
  },
  [AllergyName.HydrochlorothiazideLisinopril]: {
    category: Category.Drug,
    displayName: 'Hydrochlorothiazide-Lisinopril',
    name: AllergyName.HydrochlorothiazideLisinopril,
  },
  [AllergyName.HydrochlorothiazideLosartan]: {
    category: Category.Drug,
    displayName: 'Hydrochlorothiazide-Losartan',
    name: AllergyName.HydrochlorothiazideLosartan,
  },
  [AllergyName.HydrochlorothiazideSpironolactone]: {
    category: Category.Drug,
    displayName: 'Hydrochlorothiazide-Spironolactone',
    name: AllergyName.HydrochlorothiazideSpironolactone,
  },
  [AllergyName.HydrochlorothiazideTriamterene]: {
    category: Category.Drug,
    displayName: 'Hydrochlorothiazide-Triamterene',
    name: AllergyName.HydrochlorothiazideTriamterene,
  },
  [AllergyName.HydrocortisoneNeomycinPolymyxinBOtic]: {
    category: Category.Drug,
    displayName: 'Pediotic',
    name: AllergyName.HydrocortisoneNeomycinPolymyxinBOtic,
  },
  [AllergyName.HydrogenPeroxideTopical]: {
    category: Category.Drug,
    displayName: 'Hydrogen Peroxide Topical',
    name: AllergyName.HydrogenPeroxideTopical,
  },
  [AllergyName.Hydroxychloroquine]: {
    category: Category.Drug,
    displayName: 'Hydroxychloroquine',
    name: AllergyName.Hydroxychloroquine,
  },
  [AllergyName.Hydroxyzine]: {
    category: Category.Drug,
    displayName: 'Hydroxyzine',
    name: AllergyName.Hydroxyzine,
  },
  [AllergyName.HylanGF20]: {
    category: Category.Drug,
    displayName: 'Hylan G-F 20',
    name: AllergyName.HylanGF20,
  },
  [AllergyName.Hyoscyamine]: {
    category: Category.Drug,
    displayName: 'Hyoscyamine',
    name: AllergyName.Hyoscyamine,
  },
  [AllergyName.Ibandronate]: {
    category: Category.Drug,
    displayName: 'Ibandronate',
    name: AllergyName.Ibandronate,
  },
  [AllergyName.Imipramine]: {
    category: Category.Drug,
    displayName: 'Imipramine',
    name: AllergyName.Imipramine,
  },
  [AllergyName.Infliximab]: {
    category: Category.Drug,
    displayName: 'Infliximab',
    name: AllergyName.Infliximab,
  },
  [AllergyName.InfluenzaVirusVaccineInactivated]: {
    category: Category.Drug,
    displayName: 'Influenza Virus Vaccine, Inactivated',
    name: AllergyName.InfluenzaVirusVaccineInactivated,
  },
  [AllergyName.InfluenzaVirusVaccineLive]: {
    category: Category.Drug,
    displayName: 'Influenza Virus Vaccine, Live',
    name: AllergyName.InfluenzaVirusVaccineLive,
  },
  [AllergyName.InsulinDetemir]: {
    category: Category.Drug,
    displayName: 'Insulin Detemir',
    name: AllergyName.InsulinDetemir,
  },
  [AllergyName.InsulinGlargine]: {
    category: Category.Drug,
    displayName: 'Insulin Glargine',
    name: AllergyName.InsulinGlargine,
  },
  [AllergyName.IodineContainingCompounds]: {
    category: Category.Environment,
    displayName: 'Iodine Containing Compounds',
    name: AllergyName.IodineContainingCompounds,
  },
  [AllergyName.Iopamidol]: {
    category: Category.Drug,
    displayName: 'Iopamidol',
    name: AllergyName.Iopamidol,
  },
  [AllergyName.Ipratropium]: {
    category: Category.Drug,
    displayName: 'Ipratropium',
    name: AllergyName.Ipratropium,
  },
  [AllergyName.Irbesartan]: {
    category: Category.Drug,
    displayName: 'Irbesartan',
    name: AllergyName.Irbesartan,
  },
  [AllergyName.Iron]: {
    category: Category.Environment,
    displayName: 'Iron',
    name: AllergyName.Iron,
  },
  [AllergyName.IronDextran]: {
    category: Category.Drug,
    displayName: 'Iron Dextran',
    name: AllergyName.IronDextran,
  },
  [AllergyName.IronPolysaccharide]: {
    category: Category.Drug,
    displayName: 'Iron Polysaccharide',
    name: AllergyName.IronPolysaccharide,
  },
  [AllergyName.Isoniazid]: {
    category: Category.Drug,
    displayName: 'Isoniazid',
    name: AllergyName.Isoniazid,
  },
  [AllergyName.IsopropylAlcoholTopical]: {
    category: Category.Drug,
    displayName: 'Isopropyl Alcohol Topical',
    name: AllergyName.IsopropylAlcoholTopical,
  },
  [AllergyName.IsosorbideDinitrate]: {
    category: Category.Drug,
    displayName: 'Isosorbide Dinitrate',
    name: AllergyName.IsosorbideDinitrate,
  },
  [AllergyName.Itraconazole]: {
    category: Category.Drug,
    displayName: 'Itraconazole',
    name: AllergyName.Itraconazole,
  },
  [AllergyName.Ketoconazole]: {
    category: Category.Drug,
    displayName: 'Ketoconazole',
    name: AllergyName.Ketoconazole,
  },
  [AllergyName.Ketoprofen]: {
    category: Category.Drug,
    displayName: 'Ketoprofen',
    name: AllergyName.Ketoprofen,
  },
  [AllergyName.Ketorolac]: {
    category: Category.Drug,
    displayName: 'Ketorolac',
    name: AllergyName.Ketorolac,
  },
  [AllergyName.Kiwi]: {
    category: Category.Food,
    displayName: 'Kiwi',
    name: AllergyName.Kiwi,
  },
  [AllergyName.Lactase]: {
    category: Category.Drug,
    displayName: 'Lactase',
    name: AllergyName.Lactase,
  },
  [AllergyName.Lamotrigine]: {
    category: Category.Drug,
    displayName: 'Lamotrigine',
    name: AllergyName.Lamotrigine,
  },
  [AllergyName.Lansoprazole]: {
    category: Category.Drug,
    displayName: 'Lansoprazole',
    name: AllergyName.Lansoprazole,
  },
  [AllergyName.LatanoprostOphthalmic]: {
    category: Category.Drug,
    displayName: 'Latanoprost Ophthalmic',
    name: AllergyName.LatanoprostOphthalmic,
  },
  [AllergyName.Leflunomide]: {
    category: Category.Drug,
    displayName: 'Leflunomide',
    name: AllergyName.Leflunomide,
  },
  [AllergyName.Levetiracetam]: {
    category: Category.Drug,
    displayName: 'Levetiracetam',
    name: AllergyName.Levetiracetam,
  },
  [AllergyName.Levothyroxine]: {
    category: Category.Drug,
    displayName: 'Levothyroxine',
    name: AllergyName.Levothyroxine,
  },
  [AllergyName.Liraglutide]: {
    category: Category.Drug,
    displayName: 'Liraglutide',
    name: AllergyName.Liraglutide,
  },
  [AllergyName.Lisdexamfetamine]: {
    category: Category.Drug,
    displayName: 'Lisdexamfetamine',
    name: AllergyName.Lisdexamfetamine,
  },
  [AllergyName.Lithium]: {
    category: Category.Drug,
    displayName: 'Lithium',
    name: AllergyName.Lithium,
  },
  [AllergyName.Lobster]: {
    category: Category.Food,
    displayName: 'Lobster',
    name: AllergyName.Lobster,
  },
  [AllergyName.Loperamide]: {
    category: Category.Drug,
    displayName: 'Loperamide',
    name: AllergyName.Loperamide,
  },
  [AllergyName.Loracarbef]: {
    category: Category.Drug,
    displayName: 'Loracarbef',
    name: AllergyName.Loracarbef,
  },
  [AllergyName.Loratadine]: {
    category: Category.Drug,
    displayName: 'Loratadine',
    name: AllergyName.Loratadine,
  },
  [AllergyName.LoratadinePseudoephedrine]: {
    category: Category.Drug,
    displayName: 'Loratadine-Pseudoephedrine',
    name: AllergyName.LoratadinePseudoephedrine,
  },
  [AllergyName.Lubiprostone]: {
    category: Category.Drug,
    displayName: 'Lubiprostone',
    name: AllergyName.Lubiprostone,
  },
  [AllergyName.Lurasidone]: {
    category: Category.Drug,
    displayName: 'Lurasidone',
    name: AllergyName.Lurasidone,
  },
  [AllergyName.MagnesiumGluconate]: {
    category: Category.Drug,
    displayName: 'Magnesium Gluconate',
    name: AllergyName.MagnesiumGluconate,
  },
  [AllergyName.MeaslesMumpsRubellaVirusVaccine]: {
    category: Category.Drug,
    displayName: 'ProQuad',
    name: AllergyName.MeaslesMumpsRubellaVirusVaccine,
  },
  [AllergyName.Meclizine]: {
    category: Category.Drug,
    displayName: 'Meclizine',
    name: AllergyName.Meclizine,
  },
  [AllergyName.Medroxyprogesterone]: {
    category: Category.Drug,
    displayName: 'Medroxyprogesterone',
    name: AllergyName.Medroxyprogesterone,
  },
  [AllergyName.Melatonin]: {
    category: Category.Drug,
    displayName: 'Melatonin',
    name: AllergyName.Melatonin,
  },
  [AllergyName.Meloxicam]: {
    category: Category.Drug,
    displayName: 'Meloxicam',
    name: AllergyName.Meloxicam,
  },
  [AllergyName.MentholMethylSalicylateTopical]: {
    category: Category.Drug,
    displayName: 'Menthol-Methyl Salicylate Topical',
    name: AllergyName.MentholMethylSalicylateTopical,
  },
  [AllergyName.Mercaptopurine]: {
    category: Category.Drug,
    displayName: 'Mercaptopurine',
    name: AllergyName.Mercaptopurine,
  },
  [AllergyName.Mesalamine]: {
    category: Category.Drug,
    displayName: 'Mesalamine',
    name: AllergyName.Mesalamine,
  },
  [AllergyName.Metal]: {
    category: Category.Environment,
    displayName: 'Metal',
    name: AllergyName.Metal,
  },
  [AllergyName.Metaxalone]: {
    category: Category.Drug,
    displayName: 'Metaxalone',
    name: AllergyName.Metaxalone,
  },
  [AllergyName.Metformin]: {
    category: Category.Drug,
    displayName: 'Metformin',
    name: AllergyName.Metformin,
  },
  [AllergyName.Methadone]: {
    category: Category.Drug,
    displayName: 'Methadone',
    name: AllergyName.Methadone,
  },
  [AllergyName.Methimazole]: {
    category: Category.Drug,
    displayName: 'Methimazole',
    name: AllergyName.Methimazole,
  },
  [AllergyName.Methocarbamol]: {
    category: Category.Drug,
    displayName: 'Methocarbamol',
    name: AllergyName.Methocarbamol,
  },
  [AllergyName.Methotrexate]: {
    category: Category.Drug,
    displayName: 'Methotrexate',
    name: AllergyName.Methotrexate,
  },
  [AllergyName.Methyldopa]: {
    category: Category.Drug,
    displayName: 'Methyldopa',
    name: AllergyName.Methyldopa,
  },
  [AllergyName.Methylphenidate]: {
    category: Category.Drug,
    displayName: 'Methylphenidate',
    name: AllergyName.Methylphenidate,
  },
  [AllergyName.MiconazoleTopical]: {
    category: Category.Drug,
    displayName: 'Miconazole Topical',
    name: AllergyName.MiconazoleTopical,
  },
  [AllergyName.Milnacipran]: {
    category: Category.Drug,
    displayName: 'Milnacipran',
    name: AllergyName.Milnacipran,
  },
  [AllergyName.Mirtazapine]: {
    category: Category.Drug,
    displayName: 'Mirtazapine',
    name: AllergyName.Mirtazapine,
  },
  [AllergyName.Mites]: {
    category: Category.Environment,
    displayName: 'Mites',
    name: AllergyName.Mites,
  },
  [AllergyName.Modafinil]: {
    category: Category.Drug,
    displayName: 'Modafinil',
    name: AllergyName.Modafinil,
  },
  [AllergyName.Mold]: {
    category: Category.Environment,
    displayName: 'Mold',
    name: AllergyName.Mold,
  },
  [AllergyName.Montelukast]: {
    category: Category.Drug,
    displayName: 'Montelukast',
    name: AllergyName.Montelukast,
  },
  [AllergyName.Msg]: {
    category: Category.Food,
    displayName: 'Msg',
    name: AllergyName.Msg,
  },
  [AllergyName.Multivitamin]: {
    category: Category.Drug,
    displayName: 'Multivitamin',
    name: AllergyName.Multivitamin,
  },
  [AllergyName.MupirocinTopical]: {
    category: Category.Drug,
    displayName: 'Mupirocin Topical',
    name: AllergyName.MupirocinTopical,
  },
  [AllergyName.Mushrooms]: {
    category: Category.Food,
    displayName: 'Mushrooms',
    name: AllergyName.Mushrooms,
  },
  [AllergyName.Nabumetone]: {
    category: Category.Drug,
    displayName: 'Nabumetone',
    name: AllergyName.Nabumetone,
  },
  [AllergyName.Nadolol]: {
    category: Category.Drug,
    displayName: 'Nadolol',
    name: AllergyName.Nadolol,
  },
  [AllergyName.Nafcillin]: {
    category: Category.Drug,
    displayName: 'Nafcillin',
    name: AllergyName.Nafcillin,
  },
  [AllergyName.Nalbuphine]: {
    category: Category.Drug,
    displayName: 'Nalbuphine',
    name: AllergyName.Nalbuphine,
  },
  [AllergyName.NaloxonePentazocine]: {
    category: Category.Drug,
    displayName: 'Naloxone-Pentazocine',
    name: AllergyName.NaloxonePentazocine,
  },
  [AllergyName.Naltrexone]: {
    category: Category.Drug,
    displayName: 'Naltrexone',
    name: AllergyName.Naltrexone,
  },
  [AllergyName.Nebivolol]: {
    category: Category.Drug,
    displayName: 'Nebivolol',
    name: AllergyName.Nebivolol,
  },
  [AllergyName.Nefazodone]: {
    category: Category.Drug,
    displayName: 'Nefazodone',
    name: AllergyName.Nefazodone,
  },
  [AllergyName.Neomycin]: {
    category: Category.Drug,
    displayName: 'Neomycin',
    name: AllergyName.Neomycin,
  },
  [AllergyName.Niacin]: {
    category: Category.Drug,
    displayName: 'Niacin',
    name: AllergyName.Niacin,
  },
  [AllergyName.Nickel]: {
    category: Category.Environment,
    displayName: 'Nickel',
    name: AllergyName.Nickel,
  },
  [AllergyName.Nicotine]: {
    category: Category.Drug,
    displayName: 'Nicotine',
    name: AllergyName.Nicotine,
  },
  [AllergyName.Nifedipine]: {
    category: Category.Drug,
    displayName: 'Nifedipine',
    name: AllergyName.Nifedipine,
  },
  [AllergyName.Nitroglycerin]: {
    category: Category.Drug,
    displayName: 'Nitroglycerin',
    name: AllergyName.Nitroglycerin,
  },
  [AllergyName.NitrousOxide]: {
    category: Category.Drug,
    displayName: 'Nitrous Oxide',
    name: AllergyName.NitrousOxide,
  },
  [AllergyName.Norethindrone]: {
    category: Category.Drug,
    displayName: 'Norethindrone',
    name: AllergyName.Norethindrone,
  },
  [AllergyName.Nortriptyline]: {
    category: Category.Drug,
    displayName: 'Nortriptyline',
    name: AllergyName.Nortriptyline,
  },
  [AllergyName.Nuts]: {
    category: Category.Food,
    displayName: 'Nuts',
    name: AllergyName.Nuts,
  },
  [AllergyName.Nystatin]: {
    category: Category.Drug,
    displayName: 'Nystatin',
    name: AllergyName.Nystatin,
  },
  [AllergyName.Olanzapine]: {
    category: Category.Drug,
    displayName: 'Olanzapine',
    name: AllergyName.Olanzapine,
  },
  [AllergyName.Olmesartan]: {
    category: Category.Drug,
    displayName: 'Olmesartan',
    name: AllergyName.Olmesartan,
  },
  [AllergyName.Omega3PolyunsaturatedFattyAcids]: {
    category: Category.Drug,
    displayName: 'Omega-3 Polyunsaturated Fatty Acids',
    name: AllergyName.Omega3PolyunsaturatedFattyAcids,
  },
  [AllergyName.Omeprazole]: {
    category: Category.Drug,
    displayName: 'Omeprazole',
    name: AllergyName.Omeprazole,
  },
  [AllergyName.Onion]: {
    category: Category.Food,
    displayName: 'Onion',
    name: AllergyName.Onion,
  },
  [AllergyName.Oranges]: {
    category: Category.Food,
    displayName: 'Oranges',
    name: AllergyName.Oranges,
  },
  [AllergyName.Orphenadrine]: {
    category: Category.Drug,
    displayName: 'Orphenadrine',
    name: AllergyName.Orphenadrine,
  },
  [AllergyName.Oseltamivir]: {
    category: Category.Drug,
    displayName: 'Oseltamivir',
    name: AllergyName.Oseltamivir,
  },
  [AllergyName.Oxaprozin]: {
    category: Category.Drug,
    displayName: 'Oxaprozin',
    name: AllergyName.Oxaprozin,
  },
  [AllergyName.Oxcarbazepine]: {
    category: Category.Drug,
    displayName: 'Oxcarbazepine',
    name: AllergyName.Oxcarbazepine,
  },
  [AllergyName.Oxybutynin]: {
    category: Category.Drug,
    displayName: 'Oxybutynin',
    name: AllergyName.Oxybutynin,
  },
  [AllergyName.OxymetazolineNasal]: {
    category: Category.Drug,
    displayName: 'Oxymetazoline Nasal',
    name: AllergyName.OxymetazolineNasal,
  },
  [AllergyName.Oxytetracycline]: {
    category: Category.Drug,
    displayName: 'Oxytetracycline',
    name: AllergyName.Oxytetracycline,
  },
  [AllergyName.Paclitaxel]: {
    category: Category.Drug,
    displayName: 'Paclitaxel',
    name: AllergyName.Paclitaxel,
  },
  [AllergyName.Pantoprazole]: {
    category: Category.Drug,
    displayName: 'Pantoprazole',
    name: AllergyName.Pantoprazole,
  },
  [AllergyName.Paroxetine]: {
    category: Category.Drug,
    displayName: 'Paroxetine',
    name: AllergyName.Paroxetine,
  },
  [AllergyName.PeanutAllergenExtract]: {
    category: Category.Food,
    displayName: 'Peanut Allergen Extract',
    name: AllergyName.PeanutAllergenExtract,
  },
  [AllergyName.PenicillinGBenzathine]: {
    category: Category.Drug,
    displayName: 'Penicillin G Benzathine',
    name: AllergyName.PenicillinGBenzathine,
  },
  [AllergyName.PenicillinVPotassium]: {
    category: Category.Drug,
    displayName: 'Penicillin V Potassium',
    name: AllergyName.PenicillinVPotassium,
  },
  [AllergyName.Pentazocine]: {
    category: Category.Drug,
    displayName: 'Pentazocine',
    name: AllergyName.Pentazocine,
  },
  [AllergyName.Peppermint]: {
    category: Category.Food,
    displayName: 'Peppermint',
    name: AllergyName.Peppermint,
  },
  [AllergyName.Perflutren]: {
    category: Category.Drug,
    displayName: 'Perflutren',
    name: AllergyName.Perflutren,
  },
  [AllergyName.PermethrinTopical]: {
    category: Category.Drug,
    displayName: 'Permethrin Topical',
    name: AllergyName.PermethrinTopical,
  },
  [AllergyName.Phenazopyridine]: {
    category: Category.Drug,
    displayName: 'Phenazopyridine',
    name: AllergyName.Phenazopyridine,
  },
  [AllergyName.Phenobarbital]: {
    category: Category.Drug,
    displayName: 'Phenobarbital',
    name: AllergyName.Phenobarbital,
  },
  [AllergyName.Phentermine]: {
    category: Category.Drug,
    displayName: 'Phentermine',
    name: AllergyName.Phentermine,
  },
  [AllergyName.Phenylephrine]: {
    category: Category.Drug,
    displayName: 'Phenylephrine',
    name: AllergyName.Phenylephrine,
  },
  [AllergyName.Phenytoin]: {
    category: Category.Drug,
    displayName: 'Phenytoin',
    name: AllergyName.Phenytoin,
  },
  [AllergyName.Pioglitazone]: {
    category: Category.Drug,
    displayName: 'Pioglitazone',
    name: AllergyName.Pioglitazone,
  },
  [AllergyName.PiperacillinTazobactam]: {
    category: Category.Drug,
    displayName: 'Piperacillin-Tazobactam',
    name: AllergyName.PiperacillinTazobactam,
  },
  [AllergyName.Piroxicam]: {
    category: Category.Drug,
    displayName: 'Piroxicam',
    name: AllergyName.Piroxicam,
  },
  [AllergyName.Pneumococcal13ValentConjugateVaccine]: {
    category: Category.Drug,
    displayName: 'Pneumococcal 13-Valent Conjugate Vaccine',
    name: AllergyName.Pneumococcal13ValentConjugateVaccine,
  },
  [AllergyName.Pneumococcal23PolyvalentVaccine]: {
    category: Category.Drug,
    displayName: 'Pneumococcal 23-Polyvalent Vaccine',
    name: AllergyName.Pneumococcal23PolyvalentVaccine,
  },
  [AllergyName.Pollen]: {
    category: Category.Environment,
    displayName: 'Pollen',
    name: AllergyName.Pollen,
  },
  [AllergyName.PolyethyleneGlycol3350]: {
    category: Category.Drug,
    displayName: 'Polyethylene Glycol 3350',
    name: AllergyName.PolyethyleneGlycol3350,
  },
  [AllergyName.PolymyxinBSulfate]: {
    category: Category.Drug,
    displayName: 'Polymyxin B Sulfate',
    name: AllergyName.PolymyxinBSulfate,
  },
  [AllergyName.PolymyxinBTrimethoprimOphthalmic]: {
    category: Category.Drug,
    displayName: 'Polymyxin B-Trimethoprim Ophthalmic',
    name: AllergyName.PolymyxinBTrimethoprimOphthalmic,
  },
  [AllergyName.Pork]: {
    category: Category.Food,
    displayName: 'Pork',
    name: AllergyName.Pork,
  },
  [AllergyName.PotassiumChloride]: {
    category: Category.Drug,
    displayName: 'Potassium Chloride',
    name: AllergyName.PotassiumChloride,
  },
  [AllergyName.PovidoneIodine]: {
    category: Category.Drug,
    displayName: 'Povidone Iodine',
    name: AllergyName.PovidoneIodine,
  },
  [AllergyName.Pramipexole]: {
    category: Category.Drug,
    displayName: 'Pramipexole',
    name: AllergyName.Pramipexole,
  },
  [AllergyName.Pravastatin]: {
    category: Category.Drug,
    displayName: 'Pravastatin',
    name: AllergyName.Pravastatin,
  },
  [AllergyName.Prazosin]: {
    category: Category.Drug,
    displayName: 'Prazosin',
    name: AllergyName.Prazosin,
  },
  [AllergyName.Primidone]: {
    category: Category.Drug,
    displayName: 'Primidone',
    name: AllergyName.Primidone,
  },
  [AllergyName.Prochlorperazine]: {
    category: Category.Drug,
    displayName: 'Prochlorperazine',
    name: AllergyName.Prochlorperazine,
  },
  [AllergyName.Progesterone]: {
    category: Category.Drug,
    displayName: 'Progesterone',
    name: AllergyName.Progesterone,
  },
  [AllergyName.Propoxyphene]: {
    category: Category.Drug,
    displayName: 'Propoxyphene',
    name: AllergyName.Propoxyphene,
  },
  [AllergyName.Propranolol]: {
    category: Category.Drug,
    displayName: 'Propranolol',
    name: AllergyName.Propranolol,
  },
  [AllergyName.Pseudoephedrine]: {
    category: Category.Drug,
    displayName: 'Pseudoephedrine',
    name: AllergyName.Pseudoephedrine,
  },
  [AllergyName.PseudoephedrineTriprolidine]: {
    category: Category.Drug,
    displayName: 'Pseudoephedrine-Triprolidine',
    name: AllergyName.PseudoephedrineTriprolidine,
  },
  [AllergyName.Psyllium]: {
    category: Category.Drug,
    displayName: 'Psyllium',
    name: AllergyName.Psyllium,
  },
  [AllergyName.Quetiapine]: {
    category: Category.Drug,
    displayName: 'Quetiapine',
    name: AllergyName.Quetiapine,
  },
  [AllergyName.Quinapril]: {
    category: Category.Drug,
    displayName: 'Quinapril',
    name: AllergyName.Quinapril,
  },
  [AllergyName.Quinidine]: {
    category: Category.Drug,
    displayName: 'Quinidine',
    name: AllergyName.Quinidine,
  },
  [AllergyName.Quinine]: {
    category: Category.Drug,
    displayName: 'Quinine',
    name: AllergyName.Quinine,
  },
  [AllergyName.Rabeprazole]: {
    category: Category.Drug,
    displayName: 'Rabeprazole',
    name: AllergyName.Rabeprazole,
  },
  [AllergyName.Ragweed]: {
    category: Category.Environment,
    displayName: 'Ragweed',
    name: AllergyName.Ragweed,
  },
  [AllergyName.Raloxifene]: {
    category: Category.Drug,
    displayName: 'Raloxifene',
    name: AllergyName.Raloxifene,
  },
  [AllergyName.Ramelteon]: {
    category: Category.Drug,
    displayName: 'Ramelteon',
    name: AllergyName.Ramelteon,
  },
  [AllergyName.Ranitidine]: {
    category: Category.Drug,
    displayName: 'Ranitidine',
    name: AllergyName.Ranitidine,
  },
  [AllergyName.RedDye]: {
    category: Category.Food,
    displayName: 'Red Dye',
    name: AllergyName.RedDye,
  },
  [AllergyName.RedYeastRice]: {
    category: Category.Food,
    displayName: 'Red Yeast Rice',
    name: AllergyName.RedYeastRice,
  },
  [AllergyName.Rifampin]: {
    category: Category.Drug,
    displayName: 'Rifampin',
    name: AllergyName.Rifampin,
  },
  [AllergyName.Risedronate]: {
    category: Category.Drug,
    displayName: 'Risedronate',
    name: AllergyName.Risedronate,
  },
  [AllergyName.Risperidone]: {
    category: Category.Drug,
    displayName: 'Risperidone',
    name: AllergyName.Risperidone,
  },
  [AllergyName.Rituximab]: {
    category: Category.Drug,
    displayName: 'Rituximab',
    name: AllergyName.Rituximab,
  },
  [AllergyName.Rivaroxaban]: {
    category: Category.Drug,
    displayName: 'Rivaroxaban',
    name: AllergyName.Rivaroxaban,
  },
  [AllergyName.Rizatriptan]: {
    category: Category.Drug,
    displayName: 'Rizatriptan',
    name: AllergyName.Rizatriptan,
  },
  [AllergyName.Rofecoxib]: {
    category: Category.Drug,
    displayName: 'Rofecoxib',
    name: AllergyName.Rofecoxib,
  },
  [AllergyName.Ropinirole]: {
    category: Category.Drug,
    displayName: 'Ropinirole',
    name: AllergyName.Ropinirole,
  },
  [AllergyName.Rosiglitazone]: {
    category: Category.Drug,
    displayName: 'Rosiglitazone',
    name: AllergyName.Rosiglitazone,
  },
  [AllergyName.Rosuvastatin]: {
    category: Category.Drug,
    displayName: 'Rosuvastatin',
    name: AllergyName.Rosuvastatin,
  },
  [AllergyName.Rubber]: {
    category: Category.Environment,
    displayName: 'Rubber',
    name: AllergyName.Rubber,
  },
  [AllergyName.Salsalate]: {
    category: Category.Drug,
    displayName: 'Salsalate',
    name: AllergyName.Salsalate,
  },
  [AllergyName.Seafood]: {
    category: Category.Food,
    displayName: 'Seafood',
    name: AllergyName.Seafood,
  },
  [AllergyName.EnvironmentalAllergy]: {
    category: Category.Environment,
    displayName: 'Environmental Allergy',
    name: AllergyName.EnvironmentalAllergy,
  },
  [AllergyName.Sertraline]: {
    category: Category.Drug,
    displayName: 'Sertraline',
    name: AllergyName.Sertraline,
  },
  [AllergyName.ZosterVaccineInactivated]: {
    category: Category.Drug,
    displayName: 'Zoster Vaccine Inactivated',
    name: AllergyName.ZosterVaccineInactivated,
  },
  [AllergyName.Shrimp]: {
    category: Category.Food,
    displayName: 'Shrimp',
    name: AllergyName.Shrimp,
  },
  [AllergyName.Sildenafil]: {
    category: Category.Drug,
    displayName: 'Sildenafil',
    name: AllergyName.Sildenafil,
  },
  [AllergyName.SilverSulfadiazineTopical]: {
    category: Category.Drug,
    displayName: 'Silver Sulfadiazine Topical',
    name: AllergyName.SilverSulfadiazineTopical,
  },
  [AllergyName.Sitagliptin]: {
    category: Category.Drug,
    displayName: 'Sitagliptin',
    name: AllergyName.Sitagliptin,
  },
  [AllergyName.Solifenacin]: {
    category: Category.Drug,
    displayName: 'Solifenacin',
    name: AllergyName.Solifenacin,
  },
  [AllergyName.Spironolactone]: {
    category: Category.Drug,
    displayName: 'Spironolactone',
    name: AllergyName.Spironolactone,
  },
  [AllergyName.Strawberries]: {
    category: Category.Food,
    displayName: 'Strawberries',
    name: AllergyName.Strawberries,
  },
  [AllergyName.Streptomycin]: {
    category: Category.Drug,
    displayName: 'Streptomycin',
    name: AllergyName.Streptomycin,
  },
  [AllergyName.Sucralfate]: {
    category: Category.Drug,
    displayName: 'Sucralfate',
    name: AllergyName.Sucralfate,
  },
  [AllergyName.Sulfadiazine]: {
    category: Category.Drug,
    displayName: 'Sulfadiazine',
    name: AllergyName.Sulfadiazine,
  },
  [AllergyName.SulfamethoxazoleTrimethoprim]: {
    category: Category.Drug,
    displayName: 'Sulfamethoxazole-Trimethoprim',
    name: AllergyName.SulfamethoxazoleTrimethoprim,
  },
  [AllergyName.Sulfasalazine]: {
    category: Category.Drug,
    displayName: 'Sulfasalazine',
    name: AllergyName.Sulfasalazine,
  },
  [AllergyName.Sulfisoxazole]: {
    category: Category.Drug,
    displayName: 'Sulfisoxazole',
    name: AllergyName.Sulfisoxazole,
  },
  [AllergyName.SulfurTopical]: {
    category: Category.Drug,
    displayName: 'Sulfur Topical',
    name: AllergyName.SulfurTopical,
  },
  [AllergyName.Sulindac]: {
    category: Category.Drug,
    displayName: 'Sulindac',
    name: AllergyName.Sulindac,
  },
  [AllergyName.Sumatriptan]: {
    category: Category.Drug,
    displayName: 'Sumatriptan',
    name: AllergyName.Sumatriptan,
  },
  [AllergyName.Tamoxifen]: {
    category: Category.Drug,
    displayName: 'Tamoxifen',
    name: AllergyName.Tamoxifen,
  },
  [AllergyName.Tamsulosin]: {
    category: Category.Drug,
    displayName: 'Tamsulosin',
    name: AllergyName.Tamsulosin,
  },
  [AllergyName.Tape]: {
    category: Category.Environment,
    displayName: 'Tape',
    name: AllergyName.Tape,
  },
  [AllergyName.Tapentadol]: {
    category: Category.Drug,
    displayName: 'Tapentadol',
    name: AllergyName.Tapentadol,
  },
  [AllergyName.Temazepam]: {
    category: Category.Drug,
    displayName: 'Temazepam',
    name: AllergyName.Temazepam,
  },
  [AllergyName.Terazosin]: {
    category: Category.Drug,
    displayName: 'Terazosin',
    name: AllergyName.Terazosin,
  },
  [AllergyName.Terbinafine]: {
    category: Category.Drug,
    displayName: 'Terbinafine',
    name: AllergyName.Terbinafine,
  },
  [AllergyName.Terfenadine]: {
    category: Category.Drug,
    displayName: 'Terfenadine',
    name: AllergyName.Terfenadine,
  },
  [AllergyName.Testosterone]: {
    category: Category.Drug,
    displayName: 'Testosterone',
    name: AllergyName.Testosterone,
  },
  [AllergyName.TetanusImmuneGlobulin]: {
    category: Category.Drug,
    displayName: 'Tetanus Immune Globulin',
    name: AllergyName.TetanusImmuneGlobulin,
  },
  [AllergyName.TetanusToxoid]: {
    category: Category.Drug,
    displayName: 'Tetanus Toxoids',
    name: AllergyName.TetanusToxoid,
  },
  [AllergyName.TetanusDiphthToxoidsTdAdultAdol]: {
    category: Category.Drug,
    displayName: 'Tdap and Tetanus shot',
    name: AllergyName.TetanusDiphthToxoidsTdAdultAdol,
  },
  [AllergyName.Theophylline]: {
    category: Category.Drug,
    displayName: 'Theophylline',
    name: AllergyName.Theophylline,
  },
  [AllergyName.ThimerosalTopical]: {
    category: Category.Drug,
    displayName: 'Thimerosal Topical',
    name: AllergyName.ThimerosalTopical,
  },
  [AllergyName.Thiopental]: {
    category: Category.Drug,
    displayName: 'Thiopental',
    name: AllergyName.Thiopental,
  },
  [AllergyName.Ticagrelor]: {
    category: Category.Drug,
    displayName: 'Ticagrelor',
    name: AllergyName.Ticagrelor,
  },
  [AllergyName.Timolol]: {
    category: Category.Drug,
    displayName: 'Timolol',
    name: AllergyName.Timolol,
  },
  [AllergyName.TioconazoleTopical]: {
    category: Category.Drug,
    displayName: 'Tioconazole Topical',
    name: AllergyName.TioconazoleTopical,
  },
  [AllergyName.Tiotropium]: {
    category: Category.Drug,
    displayName: 'Tiotropium',
    name: AllergyName.Tiotropium,
  },
  [AllergyName.Tizanidine]: {
    category: Category.Drug,
    displayName: 'Tizanidine',
    name: AllergyName.Tizanidine,
  },
  [AllergyName.Tolmetin]: {
    category: Category.Drug,
    displayName: 'Tolmetin',
    name: AllergyName.Tolmetin,
  },
  [AllergyName.Tolterodine]: {
    category: Category.Drug,
    displayName: 'Tolterodine',
    name: AllergyName.Tolterodine,
  },
  [AllergyName.Tomatoes]: {
    category: Category.Food,
    displayName: 'Tomatoes',
    name: AllergyName.Tomatoes,
  },
  [AllergyName.Topiramate]: {
    category: Category.Drug,
    displayName: 'Topiramate',
    name: AllergyName.Topiramate,
  },
  [AllergyName.Trandolapril]: {
    category: Category.Drug,
    displayName: 'Trandolapril',
    name: AllergyName.Trandolapril,
  },
  [AllergyName.TravoprostOphthalmic]: {
    category: Category.Drug,
    displayName: 'Travoprost Ophthalmic',
    name: AllergyName.TravoprostOphthalmic,
  },
  [AllergyName.Trazodone]: {
    category: Category.Drug,
    displayName: 'Trazodone',
    name: AllergyName.Trazodone,
  },
  [AllergyName.Triamcinolone]: {
    category: Category.Drug,
    displayName: 'Triamcinolone',
    name: AllergyName.Triamcinolone,
  },
  [AllergyName.Triamterene]: {
    category: Category.Drug,
    displayName: 'Triamterene',
    name: AllergyName.Triamterene,
  },
  [AllergyName.TuberculinPurifiedProteinDerivative]: {
    category: Category.Drug,
    displayName: 'Tuberculin Purified Protein Derivative',
    name: AllergyName.TuberculinPurifiedProteinDerivative,
  },
  [AllergyName.Valacyclovir]: {
    category: Category.Drug,
    displayName: 'Valacyclovir',
    name: AllergyName.Valacyclovir,
  },
  [AllergyName.Valdecoxib]: {
    category: Category.Drug,
    displayName: 'Valdecoxib',
    name: AllergyName.Valdecoxib,
  },
  [AllergyName.Varenicline]: {
    category: Category.Drug,
    displayName: 'Varenicline',
    name: AllergyName.Varenicline,
  },
  [AllergyName.VaricellaVirusVaccine]: {
    category: Category.Drug,
    displayName: 'Varicella Virus Vaccine',
    name: AllergyName.VaricellaVirusVaccine,
  },
  [AllergyName.Venlafaxine]: {
    category: Category.Drug,
    displayName: 'Venlafaxine',
    name: AllergyName.Venlafaxine,
  },
  [AllergyName.Verapamil]: {
    category: Category.Drug,
    displayName: 'Verapamil',
    name: AllergyName.Verapamil,
  },
  [AllergyName.Tetrahydrozoline]: {
    category: Category.Drug,
    displayName: 'Tetrahydrozoline',
    name: AllergyName.Tetrahydrozoline,
  },
  [AllergyName.VitaminE]: {
    category: Category.Drug,
    displayName: 'Vitamin E',
    name: AllergyName.VitaminE,
  },
  [AllergyName.Warfarin]: {
    category: Category.Drug,
    displayName: 'Warfarin',
    name: AllergyName.Warfarin,
  },
  [AllergyName.Zaleplon]: {
    category: Category.Drug,
    displayName: 'Zaleplon',
    name: AllergyName.Zaleplon,
  },
  [AllergyName.ZincOxideTopical]: {
    category: Category.Drug,
    displayName: 'Zinc Oxide Topical',
    name: AllergyName.ZincOxideTopical,
  },
  [AllergyName.ZincSulfate]: {
    category: Category.Drug,
    displayName: 'Zinc Sulfate',
    name: AllergyName.ZincSulfate,
  },
  [AllergyName.Ziprasidone]: {
    category: Category.Drug,
    displayName: 'Ziprasidone',
    name: AllergyName.Ziprasidone,
  },
  [AllergyName.ZoledronicAcid]: {
    category: Category.Drug,
    displayName: 'Zoledronic Acid',
    name: AllergyName.ZoledronicAcid,
  },
  [AllergyName.Zolmitriptan]: {
    category: Category.Drug,
    displayName: 'Zolmitriptan',
    name: AllergyName.Zolmitriptan,
  },
  [AllergyName.Zolpidem]: {
    category: Category.Drug,
    displayName: 'Zolpidem',
    name: AllergyName.Zolpidem,
  },
  [AllergyName.Zonisamide]: {
    category: Category.Drug,
    displayName: 'Zonisamide',
    name: AllergyName.Zonisamide,
  },
};
